const calpak = window.calpak

const color_groups = {
  black: [
    "black",
    "trnk-black",
    "matte-black",
    "ambeur-black",
    "luka-black",
    "brushed-black",
    "wavy",
    "eclipse",
    "cheetah",
    "plaid",
    "obsidian",
    "onyx",
    "midnight-marble",
  ],
  pink: [
    "pink",
    "watermelon",
    "modern-abstract",
    "dragonfruit",
    "cranberry",
    "pink-sand",
    "rose",
    "retro-sunset",
    "pink-gold",
    "pink-n-gold",
    "canyon",
    "guava",
    "petal",
    "peony",
    "rosewood-tie-dye",
    "cappuccino-tie-dye",
    "things-between",
    "bloom",
    "rose-quartz",
    "rosewood",
    "bubblegum",
    "blush",
    "blush-pink",
    "bon-voyage",
    "terracotta",
    "aurora-pink",
    "confetti",
    "floral",
    "rose-gold",
    "shimmer-pink",
    "stripe",
    "sunset",
    "mauve",
    "sorbet",
    "jen-pink",
    "shell-pink",
    "pink-grid",
    "tea-rose",
    "persimmon",
    "blossom",
    "raspberry",
    "coral",
    "tea-rose"
  ],
  "rose-gold": ["rose-gold", "rosewood-tie-dye", "jen-pink"],
  brown: [
    "papaya",
    "ginger",
    "khaki",
    "taupe",
    "walnut",
    "espresso",
    "trnk-espresso",
    "sand-tide",
    "pumpkin",
    "gingham",
    "mocha",
    "rust",
    "cognac",
    "eclipse",
    "cheetah",
    "chocolate",
    "hazel",
    "hazelnut",
    "sand-tie-dye",
    "sand-tie-dye-wash",
    "bronze",
    "kaya-bronze",
    "caramel",
    "leopard",
    "burgundy",
    "toffee",
    "copper",
    "latte",
    "greige"
  ],
  beige: [
    "beige",
    "white-sands",
    "nude",
    "linen",
    "speckle",
    "dune",
    "sand-tide",
    "gingham",
    "oatmeal",
    "cappuccino-tie-dye",
    "polka-dot",
    "sand-tie-dye",
    "sand-tie-dye-wash",
    "trnk-almond",
    "trnk-nude",
    "cream",
    "gold-marble",
    "sand",
    "stone",
    "terrazzo",
    "bronze",
    "kaya-bronze",
    "birch",
    "latte",
    "greige"
  ],
  print: [
    "astrology",
    "trnk-almond",
    "trnk-espresso",
    "wavy",
    "sand-tide",
    "daisy",
    "cloud",
    "gingham",
    "rosewood-tie-dye",
    "cappuccino-tie-dye",
    "flora",
    "polka-dot",
    "cheetah",
    "things-between",
    "plaid",
    "bloom",
    "confetti",
    "sand-tie-dye",
    "sand-tie-dye-wash",
    "sky-tie-dye",
    "sky-tie-dye-wash",
    "floral",
    "gold-marble",
    "retro-sunset",
    "leopard",
    "groovy-blue",
    "midnight-marble",
    "milk-marble",
    "palm-leaf",
    "stars",
    "stripe",
    "sunset",
    "terrazzo",
    "mustard-bandana",
    "white-bandana",
    "tutti-fruity",
    "orchid-fields",
    "green-checkerboard",
    "pink-grid",
    "matcha",
    "tea-rose"
  ],
  purple: [
    "lavender",
    "orchid",
    "amethyst",
    "things-between",
    "groovy-blue",
    "bloom",
    "orchid-fields",
    "lilac",
    "berry",
    "raspberry"
  ],
  green: [
    "pale-green",
    "khaki",
    "modern-abstract",
    "palm",
    "green-apple",
    "kiwi",
    "honeydew",
    "pistachio",
    "sage",
    "jade",
    "kale",
    "lime",
    "forest",
    "celery",
    "juniper",
    "daisy",
    "emerald",
    "mint",
    "sage",
    "hue-olive",
    "kaya-olive",
    "palm-leaf",
    "moss",
    "groovy-blue",
    "olive",
    "green-checkerboard",
    "lime-viper",
    "key-lime",
    "matcha",
    "pine"
  ],
  blue: [
    "astrology",
    "aqua",
    "lagoon",
    "hydrangea",
    "marine",
    "winter-sky",
    "cloud",
    "stargaze",
    "mist",
    "arctic",
    "periwinkle",
    "cobalt",
    "atlantic",
    "glacier",
    "things-between",
    "sky-tie-dye",
    "sky-tie-dye-wash",
    "denim",
    "navy",
    "deep-sea",
    "sky",
    "groovy-blue",
    "wild-n-free",
    "wild-free",
    "wild-n-free",
    "fly-girl",
    "palm-leaf",
    "stars",
    "sunset",
    "bermuda",
    "bluebell",
    "powder-blue",
    "bluebell",
    "indigo"
  ],
  orange: [
    "orange",
    "papaya",
    "orange-grid",
    "retro-sunset",
    "pumpkin",
    "canyon",
    "persimmon",
    "coral",
    "clay"
  ],
  metallic: [
    "bronze",
    "kaya-bronze",
    "gold",
    "silver",
    "stargaze",
    "rose-gold",
    "copper",
    "gunmetal",
    "metallic-red",
  ],
  white: [
    "white",
    "white-sands",
    "linen",
    "dove-grey",
    "bloom",
    "sky-tie-dye",
    "sky-tie-dye-wash",
    "white-bandana",
    "confetti",
    "cream",
    "gold-marble",
    "milk-marble",
    "terrazzo",
    "stone",
  ],
  yellow: [
    "celery",
    "mustard-bandana",
    "honey",
    "gold",
    "stripe",
    "sunset",
    "pear",
    "lemonade",
    "dijon",
    "yellow",
    "butter",
    "sunshine",
  ],
  grey: [
    "grey",
    "taupe",
    "charcoal-grey",
    "trnk-grey",
    "cool-grey",
    "charcoal",
    "iron",
    "dove-grey",
    "slate",
    "silver-stardust",
    "ash",
    "gunmetal",
    "smoke"
  ],
  red: [
    "red",
    "brick",
    "watermelon",
    "terracotta",
    "cranberry",
    "rose",
    "merlot",
    "rosewood",
    "retro-sunset",
    "poppy",
    "burgundy",
    "sedona",
    "maroon",
    "pink-grid",
    "cabernet",
    "plum",
    "rouge",
    "metallic-red",
    "clay",
  ],
};
calpak.color_groups = color_groups

const colors_img = [
  ...window.cms_color_images ,
  "trnk-grey",
  "modern-abstract",
  "copper",
  "speckle",
  "orange-grid",
  "trnk-black",
  "trnk-espresso",
  "trnk-nude",
  "shimmer-pink",
  "pink-n-gold",
  "pink-gold",
  "sorbet",
  "bronze",
  "kaya-bronze",
  "gold",
  "silver",
  "rose-gold",
  "astrology",
  "trnk-almond",
  "wavy",
  "sand-tide",
  "daisy",
  "cloud",
  "gingham",
  "rosewood-tie-dye",
  "cappuccino-tie-dye",
  "flora",
  "polka-dot",
  "cheetah",
  "things-between",
  "plaid",
  "bloom",
  "confetti",
  "sand-tie-dye",
  "sand-tie-dye-wash",
  "sky-tie-dye",
  "sky-tie-dye-wash",
  "floral",
  "gold-marble",
  "leopard",
  "midnight-marble",
  "milk-marble",
  "palm-leaf",
  "stars",
  "stripe",
  "sunset",
  "terrazzo",
  "mustard-bandana",
  "white-bandana",
  "tutti-fruity",
  "retro-sunset",
  "groovy-blue",
  "pink-grid",
  "green-checkerboard",
  "orchid-fields",
  "steel",
  "gunmetal",
  "lime-viper",
  "metallic-red",
  "matcha",
  "tea-rose",
  "oatmeal-cherry",
  "blossom-cherry"
];
calpak.colors_img = colors_img

const pdpGrid = document.querySelector(".pdp__grid");

if (pdpGrid) {
  function handleResize() {
    const selectedColor = document.querySelector(".pdp__selected-variant");
    const tooltip = document.querySelector(".tooltip__message");
    // console.log("selectedColor offset width", selectedColor.offsetWidth);
    let widthnumber;
    if(window.innerWidth <= 450 ){
      widthnumber = 45
    }
    if(window.innerWidth <= 400) {
      widthnumber = 30
    }
    if (selectedColor.offsetWidth > widthnumber) {
      tooltip.classList.add("extra")
    } else {
      tooltip.classList.remove("extra")
    }
    if (selectedColor.offsetWidth > 100) {
      tooltip.classList.add("extra_large")
    } else {
      tooltip.classList.remove("extra_large")
    }
  }

  window.addEventListener('resize', handleResize);

  function observeSelectedColorChanges() {
    const targetNode = document.querySelector('.pdp__selected-variant');
    if(targetNode != null){
    const observer = new MutationObserver(() => {
      handleResize();
    });
    const config = { childList: true, subtree: true };
    observer.observe(targetNode, config);
    }
  }
  observeSelectedColorChanges();
}

function isSafari() {
  return (
    navigator.userAgent.indexOf("Safari") > -1 &&
    navigator.userAgent.indexOf("Chrome") === -1
  );
}

const getColorGroup = function(color) {
  for (let grp in color_groups) {
    for (let i = 0; i < color_groups[grp].length; i++) {
      if (color_groups[grp][i] == color)
        return {
          group: grp,
          colors: color_groups[grp],
        };
    }
  }

  return {
    group: "black",
    colors: [],
  };
}
calpak.getColorGroup = getColorGroup

const isset = function(i) {
  return i != null && i != undefined;
}
calpak.isset = isset

function quoteattr(s) {
  return ("" + s)
    .replace(/&/g, "&amp;")
    .replace(/'/g, "&apos;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

const getIndex = function(el) {
  let i = 0;
  while ((el = el.previousElementSibling) != null) ++i;
  return i;
}
calpak.getIndex = getIndex

const getIndexWithSelector = function getIndexWithSelector(el, selector) {
  let index = 0,
    matches = el.parentNode.querySelectorAll(selector);

  if (matches.length == 0) return false;

  for (let i = 0; i < matches.length; i++) {
    if (matches[i] == el) break;
    index++;
  }
  return index;
}
calpak.getIndexWithSelector = getIndexWithSelector

const stripHTML = function(text) {
  return new DOMParser()?.parseFromString(text, "text/html")?.body?.textContent;
};
calpak.stripHTML = stripHTML

const handleize = (str)=> {
  if (!str) return "";
  return str
    .toLowerCase()
    .replace(/[^\w\u00C0-\u024f]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
calpak.handleize = handleize

function unhandleize(str) {
  if (!str) return "";
  return str.replaceAll("-", " ");
}
calpak.unhandleize = unhandleize

function capitalize(str) {
  str = str.toLowerCase();
  return str.charAt(0).toUpperCase() + str.slice(1);
}
calpak.capitalize = capitalize

function capitalizeEachWord(str) {
  return str.split(' ').map(word => {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }).join(' ');
}
calpak.capitalizeEachWord = capitalizeEachWord

let currencySymbol;
let currencyCode;

const waitForElement = (selector) => {
  return new Promise((resolve) => {
    const check = () => {
      const element = document.querySelector(selector);
      if (element) {
        resolve(element);
      } else {
        requestAnimationFrame(check);
      }
    };
    check();
  });
};

const handleProductUnitPrice = (element) => {
  currencySymbol = element.getAttribute("data-currency-symbol");
  currencyCode = element.getAttribute("data-currency-code");
};

waitForElement(".product-unit__price").then(handleProductUnitPrice);

// TODO, refactor so global function doesn't need to be set like this
window.formatPrice = function formatPrice(x) {
  x = Number(x);
  if (isNaN(x)) return x;
  return (
    `${currencySymbol || "$"}${x
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      .replace(".00", "")}
       ${currencyCode != 'USD'? currencyCode : ""}`
  );
}

const getImage = function(src, sizes = "", alt = "") {
  return `<img src="${src}" srcset="${lazyloadImageSrcset(
    src
  )}" alt="${alt}" sizes="${sizes}">`;
}
calpak.getImage = getImage

const lazyloadImageSrcset = function (src, widths = [400], avif = false) {
  if (!src) return;
  // let widths = [100, 180, 300, 360, 450, 650, 800, 1000, 1200, 1600, 2000];
  // src = src.split("?");
  // src = src[0].replace(/\.(jpg|png|jpeg|gif)/, "_{width}x.$1");
  // src = src[0].replace(/\.(jpg|png|jpeg|gif)/, "_{width}x.$1");

  /* common screen sizes
  2560x1440 - 3% - 1440p
  1920x1200 - 1% - 1220p
  1920x1080 - 22% - 1080p
  1600x900 - 3%
  1536x864 - 7%
  1440x900 - 9%
  1366x768 - 12%
  1280x1024 - 4%
  1280x720 - 5%

  macbook air 13" 2560x1664 - viewport 1280x832
  macbook air 15" 2880x1864 - viewport 1440x932
  macbook pro 3024x1964 - viewport 1512x982
  imac 24" 4480x2520 - viewport 2240x1260
  */

  // src = src.replace('http://', '//')
  // src = src.replace('https://', '//')

  let _image_srcset = [];
  if (widths.length > 1) {
    for (let i = 0; i < widths.length; i++) {
      _image_srcset.push(
          src + `&width=${widths[i]} ${widths[i]}w`
          // src.replace("_{width}x.", "_" + widths[i] + "x.") + " " + widths[i] + "w"
      );
    }
  } else {
    _image_srcset.push(`${src}&width=400${avif? '&em-format=avif':''} 800w`)
    _image_srcset.push(`${src}&width=500${avif? '&em-format=avif':''} 1000w`)
    _image_srcset.push(`${src}&width=600${avif? '&em-format=avif':''} 1200w`)
  }
  return _image_srcset;
}
calpak.lazyloadImageSrcset = lazyloadImageSrcset

function redirectCustomerOnLogout() {
  const REDIRECT_PATH = window.location.pathname;
  const logoutBtns = document.querySelectorAll('a[href^="/account/logout"]');
  logoutBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      fetch(btn.href).then(() => window.location.href = REDIRECT_PATH.includes('account')?"/":REDIRECT_PATH)
    })
  })
}

/**
 * Create a mutation observer to watch for when links with a[href^="/account/logout"] are added to the DOM
 */
const redirectObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    if (mutation.addedNodes && mutation.addedNodes.length > 0) {
      mutation.addedNodes.forEach(function (node) {
        if (node.tagName === 'A' && node.href.includes('/account/logout') || node.tagName === "LI") {
          redirectCustomerOnLogout();
        }
      });
    }
  });
});

window.addEventListener('DOMContentLoaded', function () {
  redirectObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})

window.addEventListener('load', function () {
  redirectCustomerOnLogout();
})



// function loadStyle(src) {
//   return new Promise((resolve, reject) => {
//     const s = document.createElement("link");
//
//     s.setAttribute("href", src);
//     s.setAttribute("rel", "stylesheet");
//     s.setAttribute("type", "text/css");
//     s.addEventListener("load", resolve);
//     s.addEventListener("error", reject);
//
//     document.body.appendChild(s);
//   });
// }

///////////////////////// TABS ///////////////////////////
document.addEventListener("calpak:ready", function (e) {
const tabButtons = document.querySelectorAll(".tabs__button");
for (let i = 0; i < tabButtons.length; i++)
  tabButtons[i].addEventListener("click", (e) => {
    e.preventDefault();
    const nav = e.target.closest(".tabs__nav");
    const index = e.target.getAttribute("data-index");
    const tabsContainer = nav.nextElementSibling;

    const activeButtons = nav.querySelectorAll(".tabs__button--active");
    activeButtons.forEach((active) =>
      active.classList.remove("tabs__button--active")
    );
    activeButtons.forEach((active) =>
      active.setAttribute("aria-selected", "false")
    );
    activeButtons.forEach((active) => active.setAttribute("tabindex", "-1"));
    e.target.classList.add("tabs__button--active");
    e.target.setAttribute("aria-selected", "true");
    e.target.setAttribute("tabindex", "0");

    const activeContent = tabsContainer.querySelectorAll(
      ".tabs__content--active"
    );
    activeContent.forEach((active) =>
      active.classList.remove("tabs__content--active")
    );

    const tab = tabsContainer.querySelector(
      `.tabs__content[data-index="${index}"]`
    );
    if (tab) {
      tab.classList.add("tabs__content--active")

      //activate sliders in tab (slider swatch arrows)
      const sliders = tab.querySelectorAll(".product-unit__swatches.swatches-container.slider");
      // const sliders = tab.querySelectorAll(".slider");
      sliders.forEach(slider => {
        setTimeout(() => {
          calpak.checkSlider(slider);
        }, 10)
      });
    }

    setTimeout(() => {
      document.querySelectorAll(".custom-attr").forEach(element => element.removeAttribute("tabindex"));
    }, 700)
  });
});

/* Tab keyboard navigation */
let tablist, tabs, tabpanels;
let focusedTabIndex = 0;

document.addEventListener("calpak:ready", function (e) {
  tablist = document.querySelector("#featured-col__navigation");
  tabs = document.querySelectorAll("#featured-col__navigation .tabs__button");
  tabpanels = document.querySelectorAll(
      "#featured-col__navigation .tabs__content"
  );

  if (tablist) {
    // Focus previous/next tabs using Left and Right arrow keys
    tablist.addEventListener("keydown", function (e) {
      switch (e.key) {
        case "ArrowLeft":
          focusPreviousTab();
          break;

        case "ArrowRight":
          focusNextTab();
          break;

        case "Home": // optional
          e.preventDefault(); // prevent page scroll
          focusFirstTab();
          break;

        case "End": // optional
          e.preventDefault(); // prevent page scroll
          focusLastTab();
          break;
      }
    });
  }
});


/**
  Tab selection
*/
function focusPreviousTab() {
  if (focusedTabIndex > 0) {
    focusedTabIndex -= 1;
  } else {
    focusedTabIndex = tabs.length - 1;
  }

  tabs[focusedTabIndex].focus();
}

function focusNextTab() {
  if (focusedTabIndex < tabs.length - 1) {
    focusedTabIndex += 1;
  } else {
    focusedTabIndex = 0;
  }

  tabs[focusedTabIndex].focus();
}

function focusFirstTab() {
  focusedTabIndex = 0;
  tabs[focusedTabIndex].focus();
}

function focusLastTab() {
  focusedTabIndex = tabs.length - 1;
  tabs[focusedTabIndex].focus();
}

function selectTab(index) {
  // Deactivate all tabs
  tabs.forEach(function (tab) {
    tab.setAttribute("aria-selected", false);
    tab.setAttribute("tabindex", -1);
  });

  // Activate only the requested tab, and set focus to it
  tabs[index].setAttribute("aria-selected", true);
  tabs[index].setAttribute("tabindex", 0);
  tabs[index].focus();
  focusedTabIndex = index;

  // Hide all tabpanels
  tabpanels.forEach(function (tabpanel) {
    tabpanel.classList.remove("is-visible");
  });

  // Show only the tabpanel for the requested tab
  var nextTabpanel = document.querySelector(
    "#" + tabs[index].getAttribute("aria-controls")
  );
  nextTabpanel.classList.add("is-visible");
}

/////////////////////// END TABS /////////////////////////

const stickyClose = document.querySelectorAll(".sticky-promo__close");
stickyClose.forEach((close) =>
  close.addEventListener(
    "click",
    (e) => (e.target.closest(".sticky-promo").style.display = "none")
  )
);

/////////////////////// PRODUCT UNITS /////////////////////////

const setProductData = async function (
  product,
  target,
  current_variant_id = false,
  init1 = false
) {
  if(!product)
    return;
  const isProductUnit = target.classList.contains("product-unit");
  const handle = product.handle;
  let optionIsAmount = false;
  let tags = product.tags;
  let color_groups = product.color_groups || [];
  let ea_color_groups = product.ea_color_groups || [];
  let monochrome_colors = product.monochrome_colors || [];
  let hide_variants = product.hide_variants || [];

  // console.log('setProductData')

  if (typeof tags == "string") tags = tags.split(", ");
  let colorIndex = false;
  let sizeIndex = false;
  let groups = [],
    hide = [];
  let finalSale = [];
  let true_finalSale = [];

  let collection = false,
      collectionLimit = false,
      earlyAccessEnabled = product.earlyAccess,
      earlyAccessVar = target.hasAttribute("data-early-access")

  if (isProductUnit) collection = target.getAttribute("data-collection");

  // const selectSize = target.querySelector(".button-msg-add");
  const selectSizeItems = target.querySelector(
      ".product-unit__title .product-link"
  );
  const hasSizeSelector = target.querySelector(".product-unit__sizes")  ? true  : false;
  const monochromeVariants = target.getAttribute("data-monochrome-variants");
  const showMonochrome = target.getAttribute("data-show-monochrome");
  const isMonochromeView = target.getAttribute("data-is-monochrome-view");

  if(ea_color_groups.length > 0) {
    ea_color_groups.forEach((group) => {
      if (!isProductUnit && earlyAccessEnabled && earlyAccessVar !== false) {
        if (group.indexOf("ea-group1:") > -1) {
          groups[0] = group.replace("ea-group1:", "").split(":");
          if (groups[0].length > 1) groups[0][1] = groups[0][1].split(";");
        } else if (group.indexOf("ea-group2:") > -1) {
          groups[1] = group.replace("ea-group2:", "").split(":");
          if (groups[1].length > 1) groups[1][1] = groups[1][1].split(";");
        } else if (group.indexOf("ea-monochrome:") > -1) {
          groups[2] = [];
          groups[2][0] = "Monochrome";
          groups[2][1] = group.replace("ea-monochrome:", "").split(";");
        }
      }
    });
  }

  if(color_groups.length > 0) { 
    color_groups.forEach((group) => {
      if (!earlyAccessEnabled && earlyAccessVar == false) {
        if (group.indexOf("group1:") === 0) {
          if (typeof groups[0] == "undefined") {
            groups[0] = group.replace("group1:", "").split(":");
            if (groups[0].length > 1) groups[0][1] = groups[0][1].split(";");
          }
        } else if (group.indexOf("group2:") === 0) {
          if (typeof groups[1] == "undefined") {
            groups[1] = group.replace("group2:", "").split(":");
            if (groups[1].length > 1) groups[1][1] = groups[1][1].split(";");
          }
        }
      }
    });
  }

  if(monochrome_colors.length > 0 && !earlyAccessEnabled && earlyAccessVar == false) {
    if (typeof groups[2] == "undefined") {
      groups[2] = [];
      groups[2][0] = "Monochrome";
      groups[2][1] = monochrome_colors;
    }
  }

  if(hide_variants.length > 0) {
    hide_variants.forEach((hide_variant) => {
      let handled_tg = handleize(hide_variant);
      const element = document.querySelectorAll('.product-option');
      element.forEach((el) => {
        const data = el.getAttribute("data-value");
        if (handled_tg.includes(data)) {
          el.remove();
        }
      })
      setTimeout(() => {
        const ele = document.querySelectorAll('.product-unit__select.sizes-container .size-swatch');
        ele.forEach((el) => {
          const data = el.getAttribute("data-title");
          if (handled_tg.includes(data)) {
            el.remove();
          }
        })
      }, 500);

      hide.push(handled_tg);
    });
  }

  tags.forEach((tag) => {
    let tg = handleize(tag);

    // if (tag.indexOf("hide:") !== -1) {
    //   const element = document.querySelectorAll('.product-option');
    //   element.forEach((el) => {
    //     const data = el.getAttribute("data-value");
    //     if (tg.includes(data)) {
    //       el.remove();
    //     }
    //   })
    //   setTimeout(() => {
    //     const ele = document.querySelectorAll('.product-unit__select.sizes-container .size-swatch');
    //     ele.forEach((el) => {
    //       const data = el.getAttribute("data-title");
    //       if (tg.includes(data)) {
    //         el.remove();
    //       }
    //     })
    //   }, 500);
    // }

    // if (!isProductUnit && earlyAccessEnabled && earlyAccessVar !== false) {
    //   if (tag.indexOf("ea-group1:") > -1) {
    //     groups[0] = tag.replace("ea-group1:", "").split(":");
    //     if (groups[0].length > 1) groups[0][1] = groups[0][1].split(";");
    //   } else if (tag.indexOf("ea-group2:") > -1) {
    //     groups[1] = tag.replace("ea-group2:", "").split(":");
    //     if (groups[1].length > 1) groups[1][1] = groups[1][1].split(";");
    //   } else if (tag.indexOf("ea-monochrome:") > -1) {
    //     groups[2] = [];
    //     groups[2][0] = "Monochrome";
    //     groups[2][1] = tag.replace("ea-monochrome:", "").split(";");
    //   }
    // } else {
    //   if (tag.indexOf("group1:") === 0) {
    //     if (typeof groups[0] == "undefined") {
    //       groups[0] = tag.replace("group1:", "").split(":");
    //       if (groups[0].length > 1) groups[0][1] = groups[0][1].split(";");
    //     }
    //   } else if (tag.indexOf("group2:") === 0) {
    //     if (typeof groups[1] == "undefined") {
    //       groups[1] = tag.replace("group2:", "").split(":");
    //       if (groups[1].length > 1) groups[1][1] = groups[1][1].split(";");
    //     }
    //   } else if (tag.indexOf("monochrome:") === 0) {
    //     if (typeof groups[2] == "undefined") {
    //       groups[2] = [];
    //       groups[2][0] = "Monochrome";
    //       groups[2][1] = tag.replace("monochrome:", "").split(";");
    //     }
    //   }
    // }

    // if (tag.indexOf("hide:") === 0) {
    //   let _hide = tag.replace("hide:", "").split(";");
    //   hide.push(..._hide);
    // } 
    if (tag.indexOf("early-access:") === 0) {
      let _hide = tag.replace("early-access:", "").split(";");
      hide.push(..._hide);
    } else if (finalSale !== true && tg.indexOf("final-sale") === 0) {
      if (tg == "final-sale") finalSale = true;
      else {
        let finalSaleSplit = tag.split(":");
        if (finalSaleSplit.length > 1) {
          let values = finalSaleSplit[1].split(";");
          if (values.length > 0)
            values.forEach((value) => finalSale.push(handleize(value)));
        }
      }
    } else if (collection && tag.indexOf(`${collection}:`) === 0) {
      collectionLimit = tag.replace(`${collection}:`, "").split(";");
    }
  });

  if (isProductUnit && target.hasAttribute("data-single"))
    collectionLimit = [target.getAttribute("data-single")];

  for (let i = 0; i < product.options.length; i++) {
    let optionName = product.options[i];
    if (product.options[i].name !== undefined) optionName = optionName.name;
    if (optionName.toLowerCase().trim().includes("color")) colorIndex = i;
    if (
      optionName.toLowerCase().trim() == "size" ||
      optionName.toLowerCase().trim() == "quantity" ||
      optionName.toLowerCase().trim() == "amount"
    ) {
      if (optionName.toLowerCase().trim() == "amount") {
        optionIsAmount = true;
      }
      sizeIndex = i;
    }
  }

  let colors = {
    _count: 0,
  };

  let sizes = {
    _count: 0,
  };

  // let options = "";
  // let maxPrice = false,
  // minPrice = false,
  let current_variant = false;

  let variantAutoSelected = current_variant_id === false;

  let availableVariants = [];
  let hideUnavailable = target.classList.contains("product-unit--only-available");

  // TODO
  //  console.log(product.variants)
  product.variants.forEach((variant) => {
    let variantAvailable = true

    const opt1 = handleize(variant.option1);
    if (
        (hideUnavailable && !variant.available) ||
        (collectionLimit !== false && collectionLimit.indexOf(opt1) === -1) ||
        (hide !== false && hide.indexOf(opt1) > -1)
    ) {
      variantAvailable = false
    }

    if (isProductUnit) {
      if (earlyAccessEnabled) {
        // Apply only when product has early access enabled
        if (earlyAccessVar === "all") ;
        else if (earlyAccessVar === "only") {
          // If collection should show all EA variants don't hide anything
          // Skip variant if only EA should be shown but this variant is not EA
          if (variant.earlyAccess !== true)
            variantAvailable = false
        } else if (variant.earlyAccess === true) {
          // Skip variant if this is not a EA collection but this variant is EA
          variantAvailable = false
        }
      } else if (variant.earlyAccess === true)
        variantAvailable = false
    } else if (variant.earlyAccess === true) {
      // If current variant is an early access variant on PDP
      if (
          !earlyAccessEnabled || // Disable variant if early access is not enabled for this PDP
          earlyAccessVar === "false" ||
          earlyAccessVar === false
      )
        variantAvailable = false
    }

    if (isMonochromeView === "true") {
      if (monochromeVariants != null && monochromeVariants !== "") {
        if (monochromeVariants.includes(opt1) === false) {
          variantAvailable = false
        }
      }
    } else {
      if (showMonochrome === "hide") {
        if (monochromeVariants != null && monochromeVariants !== "") {
          if (monochromeVariants.includes(opt1) === true) {
            variantAvailable = false
          }
        }
      }
    }

    // TODO refactor all the loops below into one
    if (variantAvailable){
      availableVariants.push(variant);
    }
  })

  // TODO remove after verifying above logic
  // for (let i = 0; i < product.variants.length; i++) {
  //   if (hideUnavailable && !product.variants[i].available) continue;
  //   const opt1 = handleize(product.variants[i].option1);
  //   if (
  //       (collectionLimit !== false && collectionLimit.indexOf(opt1) === -1) ||
  //       (hide !== false && hide.indexOf(opt1) > -1)
  //   )
  //     continue;
  //
  //   if (isProductUnit) {
  //     if (earlyAccessEnabled) {
  //       // Apply only when product has early access enabled
  //       if (earlyAccessVar == "all");
  //       else if (earlyAccessVar == "only") {
  //         // If collection should show all EA variants don't hide anything
  //         // Skip variant if only EA should be shown but this variant is not EA
  //         if (product.variants.earlyAccess !== true)
  //           continue;
  //       } else if (product.variants.earlyAccess === true) {
  //         // Skip variant if this is not a EA collection but this variant is EA
  //         continue;
  //       }
  //     } else if (product.variants.earlyAccess === true)
  //       continue;
  //   } else if (product.variants.earlyAccess === true) {
  //     // If current variant is an early access variant on PDP
  //     if (
  //         !earlyAccessEnabled || // Disable variant if early access is not enabled for this PDP
  //         earlyAccessVar == "false" ||
  //         earlyAccessVar == false
  //     )
  //       continue;
  //   }
  //
  //   if(isMonochromeView=="true") {
  //     if(monochromeVariants != null && monochromeVariants != ""){
  //       if(monochromeVariants.includes(opt1) == false){
  //         continue;
  //       }
  //     }
  //   }else{
  //     if(showMonochrome == "hide"){
  //       if(monochromeVariants != null && monochromeVariants != ""){
  //         if(monochromeVariants.includes(opt1) == true){
  //           continue;
  //         }
  //       }
  //     }
  //   }
  //
  //   availableVariants.push(product.variants[i]);
  // }

  if (isProductUnit && isset(init1) && init1 !== false) {
    init1 = handleize(init1);

    let match = false,
      backupMatch = false,
      onlyAvailable = true;

    let colorGroup = getColorGroup(init1);

    for (let i = 0; i < availableVariants.length; i++) {
      const optionColor = handleize(availableVariants[i].option1);

      if (init1 === optionColor) {
        if (!onlyAvailable || availableVariants[i].available) {
          match = availableVariants[i];
          break;
        } else {
          backupMatch = availableVariants[i];
        }
      } else if (
        match === false &&
        availableVariants[i].available &&
        colorGroup.colors.indexOf(optionColor) > -1
      )
        match = availableVariants[i];
    }

    current_variant = match || backupMatch;
    variantAutoSelected = false;

    const handle = target.getAttribute("data-handle");
    const productLinks = target.querySelectorAll(
      ".product-link, .quick-view__link"
    );
    productLinks.forEach((productLink) => {
      productLink.setAttribute(
        "href",
        `/products/${handle}/${handleize(current_variant.option1)}`
      );
    });
  }

  if (current_variant === false)
    for (let i = 0; i < availableVariants.length; i++) {
      if (current_variant_id === false) {
        current_variant = availableVariants[i];
        break;
      } else if (
        current_variant_id == availableVariants[i].id ||
        current_variant_id == handleize(availableVariants[i].option1)
      ) {
        current_variant = availableVariants[i];
        break;
      }
    }
  if (current_variant === false) current_variant = availableVariants[0];

  let hasMultipleSizes = false;

  let productOnSale = true;


  const product_tag = window.holidayGamificationData?.product_tag;
  if (window.holidayGamification !== undefined || typeof product_tag !== 'undefined') {
    if (product_tag && product.tags.find((tag) => tag === product_tag)) {
      if (isProductUnit) target.dataset.holidayGift = true;
      else {
        target.parentElement.dataset.holidayGift = true;
        const productLabelGiftGamification = target.parentElement.querySelector(".product-label--gift-gamification");
        if (typeof productLabelGiftGamification != undefined) {
          const pdp_promo_text = window.holidayGamificationData?.pdp_promo_text;
          const pdp_promo_text_non = window.holidayGamificationData?.pdp_promo_text_non;
          const product_eligible_message = window.holidayGamificationData?.product_eligible_message;
          const product_non_eligible_message = window.holidayGamificationData?.product_non_eligible_message;
          const goal_price = Number(window.holidayGamificationData?.goal_price ?? 0) * 100;
          if (current_variant.price >= goal_price) {
            productLabelGiftGamification.querySelector("strong").innerHTML = pdp_promo_text;
            productLabelGiftGamification.querySelector("span").innerHTML = product_eligible_message;
          } else {
            productLabelGiftGamification.querySelector("strong").innerHTML = pdp_promo_text_non;
            productLabelGiftGamification.querySelector("span").innerHTML = product_non_eligible_message;
          }
          productLabelGiftGamification.style.display = "flex";
        }
      }
    }
  }


  availableVariants.forEach((variant) => {
    if ( variant.compare_at_price === variant.price || variant.compare_at_price === null ) {
      productOnSale = false;
    }

    const opt1 = handleize(variant.option1);
    let opt2 = false;

    if (variant.option2 != null && variant.option2 != undefined)
      opt2 = handleize(variant.option2);

    let sizeValues = product.variants.map(variant => variant.option2);
    sizeValues = calpak.collect(sizeValues);
    sizeValues = sizeValues.unique().all();

    let colorOption = false;
    if (colorIndex === 0) colorOption = opt1;
    else if (colorIndex === 1 && opt2 != false) colorOption = opt2;

    let selected = current_variant.id == variant.id;
    let available = variant.available;

    let preorder = false,
        hover = false,
        earlyAccess = false,
        videoInfo = false;

    if (variant.preorder) preorder = variant.preorder;
    else if (product.preorder) preorder = product.preorder;

    if (variant.videoInfo) videoInfo = variant.videoInfo;
    else if (product.videoInfo) videoInfo = product.videoInfo;

    if (isProductUnit && variant.hover) hover = variant.hover;

    earlyAccess = earlyAccessVar === "all" || earlyAccessVar === "only";

    if (colorOption !== false) {
      if (colorOption in colors) {
        if (colors[colorOption].available === false && available === true)
          colors[colorOption].available = true;
        if (!colors[colorOption].preorder && preorder)
          colors[colorOption].preorder = preorder;
        if (colors[colorOption].selected === false && selected === true)
          colors[colorOption].selected = true;
      } else {
        let urlOpt1 = `${shopUrl}/products/${handle}/${earlyAccess ? "early-access-" : ""
          }${colorOption}`;
        let url;

        if (opt2 !== false && sizeValues.length > 1)
          url = `${shopUrl}/products/${handle}/${earlyAccess ? "early-access-" : ""
            }${colorOption},${handleize(current_variant.option2)}`;
        else url = urlOpt1;
        if (window.location.pathname.includes("collections")) {
          if (available === false && !preorder) {
            setTimeout(() => {
              if (
                target.querySelector(
                  `.product-unit__colors--quickadd .product-unit__colors .product-unit__swatches-container .swatches-container .color-swatch[data-value="${colorOption}"]`
                )
              )
                target
                  .querySelector(
                    `.product-unit__colors--quickadd .product-unit__colors .product-unit__swatches-container .swatches-container .color-swatch[data-value="${colorOption}"]`
                  )
                  .classList.add("product-option--na");
            }, 1000);
          }
        }
        let monochrome = false;
        if(monochromeVariants != null){
          monochrome = monochromeVariants.includes(opt1);
        }
        colors[colorOption] = {
          available: available,
          selected: selected,
          title: variant.option1,
          first_variant_id: variant.id,
          urlOpt1: urlOpt1,
          url: url,
          monochrome: monochrome,
          price: variant.price,
          sku: variant.sku,
          preorder: preorder
        };

        colors._count++;
      }
    }

    if (hasSizeSelector) {
      let sizeOption = false;
      if (sizeIndex === 0) sizeOption = opt1;
      else if (sizeIndex === 1 && opt2 != false) sizeOption = opt2;

      if (sizeOption !== false) {
        if (sizeOption in sizes) {
          if (sizes[sizeOption].available === false && available === true)
            sizes[sizeOption].available = true;
          if (sizes[sizeOption].selected === false && selected === true)
            sizes[sizeOption].selected = true;
        } else {
          sizes[sizeOption] = {
            available: available,
            selected: selected,
            title: variant.option2 ? variant.option2 : variant.option1,
            first_variant_id: variant.id,
            first_variant_price: variant.price,
          };
          sizes._count++;
        }
      }
    }

    // let variantPrice = variant.price;
    // let variantComparePrice = false;
    // if (variant.compare_at_price && variant.compare_at_price > variant.price)
    //   variantComparePrice = variant.compare_at_price;

    // if (isProductUnit) {
    //   if (maxPrice === false || variantPrice > maxPrice)
    //     maxPrice = variantPrice;
    //   if (minPrice === false || variantPrice < minPrice)
    //     minPrice = variantPrice;
    // }

    // let img = false;
    // let imgAlt = false;
    // let created = false;
    // if (variant.featured_image) {
    //   img = variant.featured_image.src;
    //   imgAlt = variant.featured_image.alt;
    //   // created = Math.floor(
    //   //   new Date(variant.featured_image.created_at).getTime() / 1000
    //   // );
    // }

    // TODO img
    // if (isProductUnit && selected && img) {
    //   console.log('setImages')
    //   let imgTag = target.querySelector(".product-unit__image img");
    //   if (!imgTag)
    //     target.querySelector(".product-unit__image").innerHTML =
    //       '<img style="opacity:1" src="">';
    //   const lazySrcset = target.querySelector(".product-unit__image img");
    //   if (target.parentNode.classList.contains("product-grid--breakdown")) {
    //     const imgBreak = target
    //       .querySelector(".product-unit__image img")
    //       .getAttribute("src");
    //     lazySrcset.setAttribute("srcset", lazyloadImageSrcset(imgBreak, [400]));
    //   } else {
    //     lazySrcset.setAttribute("srcset", lazyloadImageSrcset(img, [400]));
    //   }
    //   if (typeof imgAlt !== undefined && imgAlt != null){
    //     lazySrcset.setAttribute('alt', imgAlt)
    //   }
    //   // let altHover = target
    //   //   .querySelector(".product-unit__image img")
    //   //   .getAttribute("alt");
    //   if (hover) {
    //     let hoverImg = target.querySelector(".product-unit__image img.img-hover");
    //     // let hoverImg = document.createElement("img");
    //     hoverImg?.setAttribute("src", hover);
    //     hoverImg?.setAttribute("srcset", lazyloadImageSrcset(hover, [400]));
    //     let sizes =  target.querySelector(".product-unit__image img").getAttribute("sizes")
    //     if (sizes != null){
    //       hoverImg?.setAttribute("sizes", sizes)
    //     }
    //
    //     // hoverImg.classList.add("img-hover");
    //     // hoverImg.setAttribute("loading", "eager");
    //     // hoverImg.setAttribute("alt", altHover);
    //     if (typeof imgAlt !== undefined && imgAlt != null){
    //       hoverImg?.setAttribute('alt', imgAlt)
    //     }
    //     // target.querySelector(".product-unit__image").appendChild(hoverImg);
    //     if (
    //       target.parentNode.classList.contains("free-gift__selector-product")
    //     ) {
    //       hoverImg?.remove();
    //     }
    //   }
    // }

    // options += `<option
    //             ${selected ? 'selected="selected"' : ""}
    //             ${img ? `data-image="${img}"` : ""}
    //             data-option1="${opt1}"
    //             data-option2="${opt2}"
    //             ${earlyAccess ? "data-early-access" : ""}
    //             ${created ? `data-created="${created}"` : ""}
    //             data-sku="${handleize(variant.sku)}"
    //             ${hover ? `data-hover="${hover}"` : ""}
    //             ${imgAlt ? `data-alt="${imgAlt}"` : ""}
    //             ${videoInfo ? `data-video-info="${quoteattr(videoInfo)}"` : ""}
    //             ${preorder ? `data-preorder="${quoteattr(preorder)}"` : ""}
    //             ${finalSale === true || finalSale.indexOf(opt1) > -1
    //     ? "data-final-sale"
    //     : ""
    //   }
    //             ${true_finalSale === true || true_finalSale.indexOf(opt1) > -1
    //     ? "data-true-final-sale"
    //     : ""
    //   }
    //             data-qty="${variant.inventory_policy == "deny" &&
    //     variant.inventory_quantity <= 10
    //     ? variant.inventory_quantity
    //     : ""
    //   }"
    //             data-available="${available}"
    //             value="${variant.id}"
    //             data-price="${variantPrice}"
    //             ${variantComparePrice
    //     ? `data-cprice="${variantComparePrice}"`
    //     : ""
    //   }
    //             data-soldout-all-variants="${product.tags.find((tag) => tag === "soldout") ? true : false
    //   }"
    //             data-soldout-this-variant="${product.tags
    //     .find((tag) => tag.includes(`soldout`))
    //     ?.split(":")[1]
    //     ?.split(",")
    //     .find((color) => color === opt1)
    //     ? true
    //     : false
    //   }"
    //             >
    //                 ${variant.title}
    //         </option>`;
  });
  if (hasMultipleSizes !== true) hasMultipleSizes = false;

  // TODO REFACTOR select
  // let select = document.createElement("select");
  // select.classList.add("variant-select");
  // select.classList.add("hide");
  // select.setAttribute("name", "id");
  // select.setAttribute("aria-label", "Product variant");
  // select.innerHTML = options;
  // let defaultVariant = typeof target.querySelector === "function" ? target.querySelector(".variant_data") : null
  // if (defaultVariant) {
  //   defaultVariant.innerHTML = "";
  //   defaultVariant.appendChild(select);
  // } else if (typeof target.appendChild === "function") {
  //   target.appendChild(select)
  // }

  if (isProductUnit) {
    // select.setAttribute("data-min-price", minPrice);
    // select.setAttribute("data-max-price", maxPrice);
    // let date = new Date(product.created_at);
    // select.setAttribute("data-created", Math.floor(date.getTime() / 1000));

    for (let i = 0; i < product.options.length; i++) {
      if (product.options[i].toLowerCase().trim() === "color") continue;

      let optionInput = document.createElement("input");
      optionInput.setAttribute("type", "hidden");
      optionInput.setAttribute("data-position", i + 1);
      optionInput.classList.add("product-unit__option");
      if (typeof current_variant !== 'undefined') {
        // NB TODO https://www.calpaktravel.com/collections/luggage
        // troubleshoot current_variant 'undefined' for
        // https://www.calpaktravel.com/products/astyll-carry-on-luggage
        optionInput.value = handleize(current_variant[`option${i + 1}`]);
      }
      target.appendChild(optionInput);
    }
  }

  if (colors._count === 0) {
    if (optionIsAmount) {
      if (hasSizeSelector) {
        let currentSize = false;
        const selects = target.querySelector(".product-unit__sizes");
        const sizesContainer = selects.querySelector(".sizes-container");
        const component = target.querySelector(
          ".product-unit__select--seleted"
        );
        const atcBtn = target.querySelector(".product-unit__button");
        for (const size in sizes) {
          if (size == "_count") continue;

          let el = document.createElement("a");
          el.setAttribute("href", "#");
          el.classList.add("size-swatch");
          el.classList.add("no-color");
          el.classList.add("size-" + size);
          el.setAttribute("title", sizes[size].title);
          el.setAttribute("data-title", size);
          el.setAttribute("data-value", size);
          el.value = size;
          el.setAttribute(
            "data-first-variant-id",
            sizes[size].first_variant_id
          );
          if (
            target
              .querySelector(".product-unit__select--seleted")
              .innerHTML.trim() == ""
          ) {
            el.classList.add("selected");
            target.querySelector(
              ".product-unit__select--seleted"
            ).innerHTML = `<span>${sizes[size].title}</span> <span>$${sizes[size].first_variant_price / 100
              }</span>`;
          }

          if (sizes[size].available === false)
            el.classList.add("product-option--na");

          if (sizes[size].selected === true) {
            el.classList.add("size-swatch--active");
            currentSize = sizes[size].title;
            if (!variantAutoSelected) el.classList.add("size-swatch--first");
          }

          if (sizes[size].available === false && sizes[size].selected === true)
            target.classList.add("product-unit--na");

          el.innerHTML = `<span>${sizes[size].title}</span> <span>$${sizes[size].first_variant_price / 100
            }</span>`;

          sizesContainer.appendChild(el);
        }
        if (window.innerWidth < 900) {
          atcBtn.querySelector(".button--add-to-cart").style.pointerEvents =
            "none";
          target.addEventListener("mouseover", (e) => {
            component.classList.add("hovered");
          });
          target.addEventListener("mouseout", (e) => {
            if (!component.classList.contains("focused")) {
              component.classList.remove("hovered");
            }
          });
          component.addEventListener("click", (e) => {
            component.classList.toggle("focused");
          });
          atcBtn.addEventListener("click", (e) => {
            component.classList.add("focused");
            atcBtn.querySelector(".button--add-to-cart").style.pointerEvents =
              "auto";
            atcBtn.classList.add("ready");
          });

          const sizeSwatches = target.querySelectorAll(".size-swatch");
          sizeSwatches.forEach((sizeSwatch) =>
            sizeSwatch.addEventListener("click", (e) => {
              component.classList.remove("focused");
            })
          );
        } else {
          const checkSelected = target.querySelector(
            ".product-unit--quickadd .product-unit__size-component label"
          );
          target.addEventListener("mouseover", (e) => {
            component.classList.add("hovered");
          });
          const checkboxes = document.querySelectorAll(
            ".product-unit--quickadd .product-unit__size-component input"
          );
          checkboxes.forEach((checkbox) => {
            checkbox.addEventListener("change", (e) => {
              if (e.target.checked) {
                checkboxes.forEach((otherCheckbox) => {
                  if (otherCheckbox !== e.target) {
                    otherCheckbox.checked = false;
                  }
                });
              }
            });
          });
        }

        if (sizes._count <= 1) {
          selects.parentNode.classList.add("hide");
        }
      }
      return;
    } else {
      return;
    }
  }

  // Swatches
  if (!isProductUnit) {/*
    let swatchesCheck = new Set();
    let swatchesElements = [];

    availableVariants.forEach((variant) => {
      if (!swatchesCheck.has(variant.option1)) {
        swatchesCheck.add(variant.option1);
        const varHandle = handleize(variant.option1);
        const varhandlesize = handleize(variant.option2);
        const varOnSale =
          variant.compare_at_price && variant.compare_at_price >= variant.price
            ? "true"
            : "false";
        if (hide.indexOf(varHandle) === -1) {
          let pushGroupIndex = 0;
          if (
            groups.length > 1 &&
            ((groups[0].length > 1 && groups[0][1].indexOf(varHandle) === -1) ||
              (groups[0].length === 1 &&
                groups[1].length > 1 &&
                groups[1][1].indexOf(varHandle) > -1))
          ) {
            pushGroupIndex = 1;
          }
          if (
            groups.length > 2 &&((groups[1].length > 1 && groups[1][1].indexOf(varHandle) === -1) ||
              (groups[2] != undefined && groups[1].length === 1 &&
                groups[2].length > 1 &&
                groups[2][1].indexOf(varHandle) > -1))
          ) {
            pushGroupIndex = 2;
          }

          if (swatchesElements[pushGroupIndex] === undefined)
            swatchesElements[pushGroupIndex] = "";

          let img = "";
          if (colors_img.indexOf(varHandle) > -1)
            img = `<img alt="Swatch for ${varHandle}" src='${filesUrl.replace(
              "file.svg",
              `${varHandle}.png`
            )}'>`;

          let earlyAccess = false;
          if (
              product.earlyAccess == true &&
            variant.earlyAccess == true
          )
            earlyAccess = true;
          var url = "";
          if (varhandlesize != "") {
            url = `${shopUrl}/products/${product.handle}/${earlyAccess ? "early-access-" : ""
              }${varHandle},${varhandlesize}`;
          } else {
            url = `${shopUrl}/products/${product.handle}/${earlyAccess ? "early-access-" : ""
              }${varHandle}`;
          }
          let activeSwatch = varHandle == handleize(current_variant.option1);

          // const variantImg = `<img class="pdp-variant-img pdp-variant-img-event pdp-variant-img-event-${product.handle}-${varHandle}" alt="Swatch for ${varHandle}" style="display:none;"
          // src="${variant.featured_image.src.replace(".jpg","_200x.jpg")}"
          // >`

          swatchesElements[pushGroupIndex] +=
            `<a
                        href="${url}"
                        data-value="${varHandle}"
                        title="${capitalize(variant.option1)}"
                        role="radio"
                        tabindex="0"
                        aria-checked="false"
                        class="color-swatch pdp-variant-img color-${varHandle}${activeSwatch ? " color-swatch--active" : ""
            }${colors[varHandle].available ? "" : " product-option--na"} ${varOnSale == "true" && productOnSale == false
              ? "color-swatch-sale"
              : ""
            }">
                        ` +
            img +
            `
                    <input type="radio" style="display: none"/><label class="visually-hidden">${capitalize(
              variant.option1
            )}</label>



            </a>`;
        }
      }
    });

    const swatchesGroupsEl = typeof target.querySelector === "function" ? target.querySelector(".pdp__swatches-groups") : false
    if (!swatchesGroupsEl) return;

    let swatchesGroupsElHTML = '';
    for (let i = 0; i < swatchesElements.length; i++) {
      let label = "";
      if (groups.length > 0 && typeof groups[i] != undefined) {
        label = `<label>${groups[i][0]}</label>`;
        if (groups[i][0]=="Monochrome") {
          label = `<label>${groups[i][0]}<span id="toggle_tooltip" class="tooltip">i<span class="tooltip__message">Exterior color matches interior color</span></span></label>`;
        }
      }
      if (label.includes("Monochrome")) {
        swatchesGroupsElHTML = `<div class="pdp__swatches-group monochrome">
                ${groups.length > 0 ? label : "<label>Classics</label>"}
                <div class="pdp__swatches">${swatchesElements[i]}</div>
            </div>` + swatchesGroupsElHTML;
      } else {
        swatchesGroupsElHTML += `<div class="pdp__swatches-group">
                ${groups.length > 0 ? label : "<label>Classics</label>"}
                <div class="pdp__swatches">${swatchesElements[i]}</div>
            </div>`;
      }
    }
    swatchesGroupsEl.innerHTML = swatchesGroupsElHTML
    swatchesGroupsEl
      .querySelector(".color-swatch")
      ?.setAttribute("aria-checked", "false");
    const activeSwatch = swatchesGroupsEl.querySelector(
      `.color-swatch[data-value="${handleize(current_variant.option1)}"]`
    );
    if (activeSwatch) {
      activeSwatch.classList.add("color-swatch--active");
      activeSwatch.setAttribute("aria-checked", "true");
    } else {
      activeSwatch?.setAttribute("aria-checked", "false");
    }*/
    return;
  }

  if (target.querySelector(".product-unit__colors-text i"))
    target.querySelector(".product-unit__colors-text i").innerHTML =
      colors._count;
  if (target.querySelector(".product-unit__colors"))
    target
      .querySelector(".product-unit__colors")
      .setAttribute("data-count", colors._count);

  const swatches = target.querySelector(".product-unit__swatches");
  let allColors = null;
  if (swatches) {
    var colorsContainer = swatches.closest(".product-unit__colors");
    if(colorsContainer != null)
      allColors = colorsContainer.classList.contains(
        "product-unit__colors--all"
      );
  }

  let currentColor = false;
  let addedColors = new Set();


  const splitview_color = target.getAttribute("data-splitview-color");
  let PlpSplitView = product.plp_split_view || [];
  let splitview_color_swatches = [];
  if(splitview_color != "off")
  {
    // tags.forEach(tag=>{
    //   if(tag.indexOf("PLPsplitview") != -1)
    //   {
    //     splitview_color_swatches = tag.replaceAll("PLPsplitview:", "").split(";");
    //   }
    // })
    splitview_color_swatches = PlpSplitView;
  }

  let firstColorSwatches = [];

  const isLimitColor = target.getAttribute("data-hot-deals") || "";
  let limitedColors = [];
  if(isLimitColor == 'true')
  {
    tags.forEach(tag=>{
      if(tag.indexOf("variant-show:") != -1)
      {
        limitedColors = tag.replaceAll("variant-show:", "").split(";");
      }
    })
  }

  for (const color in colors) {
    if (color == "_count") continue;

    if (!addedColors.has(color)) {
      if(splitview_color != "off")
      {
        if(splitview_color == "only" && splitview_color_swatches.length != 0 && splitview_color_swatches.indexOf(color) == -1)
        {
          continue;
        }
        if(splitview_color == "hide" && splitview_color_swatches.length != 0 && splitview_color_swatches.indexOf(color) != -1)
        {
          continue;
        }
      }

      if(isLimitColor=="true" && limitedColors.length != 0){
        if(limitedColors.findIndex(item=>item==color)==-1)
          continue;
      }

      addedColors.add(color);

      let el = document.createElement("a");

      let url;
      url = colors[color].url;

      el.setAttribute("href", url);
      el.classList.add("color-swatch");
      if (allColors) el.classList.add("slide");
      el.classList.add("color-" + color);
      el.setAttribute("title", colors[color].title);
      el.setAttribute("data-value", color);
      el.setAttribute("data-available", colors[color].available);
      el.setAttribute("data-monochrome", colors[color].monochrome);
      el.setAttribute("data-price", colors[color].price);
      el.setAttribute("data-sku", colors[color].sku);
      el.setAttribute("data-first-variant-id", colors[color].first_variant_id);
      el.setAttribute("aria-label", colors[color].title);
      el.setAttribute("tabindex", "-1");
      el.setAttribute("aria-hidden", "true");
      el.setAttribute("aria-checked", "false");
      el.setAttribute("role", "radio");
      if (colors[color].preorder) {
        el.setAttribute("data-preorder", colors[color].preorder);
      }
      if (
        colors[color].available === false &&
        !(
          window.location.pathname.includes("collections") &&
          colors[color].preorder
        )
      )
        el.classList.add("product-option--na");

      if (colors[color].selected === true) {
        el.classList.add("color-swatch--active");
        currentColor = colors[color].title;
        if (!variantAutoSelected) {
          el.classList.add("color-swatch--first");

          const productLinks = target.querySelectorAll(
            ".product-link, .quick-view__link"
          );
          productLinks.forEach((productLink) =>
            productLink.setAttribute("href", url)
          );

          el.setAttribute("tabindex", "0");
          el.setAttribute("aria-checked", "true");
        }
      }
      let firstColorMatch = 0;
      let firstColors = product.first_colors || [];
      for (let i = 0; i < firstColors.length; i++) {
        let collectionUrl = window.location.href;
        let collectionUrlSplit = collectionUrl.replace(
          "https://www.calpaktravel.com/collections/",
          ""
        );
        if (target.closest(".promo-collection__products")) {
          collectionUrlSplit = "new-arrivals";
        }
        let tagBuilder = collectionUrlSplit + ":";
        let tagColors = firstColors[i].replace(tagBuilder, "");
        let tagColorsSplit = tagColors.split(";");
        if (firstColors[i].indexOf(tagBuilder) > -1) {
          el.classList.add("color_mutiple");
          for (let i = 0; i < tagColorsSplit.length; i++) {
            if (color == tagColorsSplit[i]) {
              el.classList.add("color_index__" + firstColorMatch.toString());
              el.style.order = firstColorMatch.toString();
            }
            firstColorMatch++;
          }
        }
      }

      let match = 0;
      const productTags = product.tags;
      for (let i = 0; i < productTags.length; i++) {
        // const collectionUrl = window.location.href;
        // let collectionUrlSplit = collectionUrl.replace(
        //   "https://www.calpaktravel.com/collections/",
        //   ""
        // );
        // if (target.closest(".promo-collection__products")) {
        //   collectionUrlSplit = "new-arrivals";
        // }
        // const tagBuilder = "first:" + collectionUrlSplit + ":";
        // const tagColors = productTags[i].replace(tagBuilder, "");
        // const tagColorsSplit = tagColors.split(";");
        // if (productTags[i].indexOf(tagBuilder) > -1) {
        //   el.classList.add("color_mutiple");
        //   for (let i = 0; i < tagColorsSplit.length; i++) {
        //     if (color == tagColorsSplit[i]) {
        //       el.classList.add("color_index__" + match.toString());
        //       el.style.order = match.toString();
        //     }
        //     match++;
        //   }
        // }

        const tagBuilder_hotdeal = "hot-deal-slider:";
        const hotdealtagColors = productTags[i].replace(tagBuilder_hotdeal, "");
        const hotdealtagColorsSplit = hotdealtagColors.split(";");
        const mainDiv = document.querySelector(".hot-deal-con");
        if (productTags[i].indexOf(tagBuilder_hotdeal) > -1) {
          el.classList.add("hot-deal");
          for (let i = 0; i < hotdealtagColorsSplit.length; i++) {
            if (color == hotdealtagColorsSplit[i]) {
              if (match.toString() == 0) {
                el.classList.add("color-swatch-hot");
              }
              el.classList.add("show-hotdeal");
            }
            match++;
          }
        }
      }
      if (colors[color].available === false && colors[color].selected === true)
        target.classList.add("product-unit--na");

      let colorImage = colors_img.filter(element => {
        if(element.includes("|")){
          let colorname = element.split("|");
          return colorname[0] === color;
        }else{
          return element === color;
        }
      })[0];

      if (colorImage != undefined) {
        let imagename = `${color}.png`;
        if(colorImage.includes("|")){
          let colorname = colorImage.split("|");
          imagename = colorname[1];
        }
        el.innerHTML = `<img alt='Swatch ${color}' src='${filesUrl.replace(
          "file.svg",
          `${imagename}`
        )}&width=60'>`;
      }

      if(splitview_color == "show" && splitview_color_swatches.length != 0 && splitview_color_swatches.indexOf(color) != -1)
      {
        firstColorSwatches.push(el)
        continue;
      }
      
      if(!swatches.closest('.pdp-gwp__product-block')){
        swatches?.appendChild(el);
      }
    }
  }

  if(firstColorSwatches.length != 0){
    firstColorSwatches.reverse().forEach(item=>swatches.insertBefore(item, swatches.firstChild));
    swatches.querySelectorAll(".color-swatch").forEach(item=>{
      item.classList.remove("color-swatch--first");
      item.classList.remove("color-swatch--active");
    })
    swatches.querySelector(".color-swatch").classList.add("color-swatch--first");
    swatches.querySelector(".color-swatch").classList.add("color-swatch--active");
  }

  swatches?.insertAdjacentHTML(
    "afterbegin",
    `<p class="swatch-container-label sr-only" id="radiogroup__${product.handle}">Select a color</p>`
  );
  swatches?.setAttribute("aria-labelledby", `radiogroup__${product.handle}`);
  // swatches?.setAttribute("role", "radiogroup");
  document.querySelectorAll(".color_index__0").forEach(function (el) {
    el.click();
  });
  document
    .querySelectorAll(".hot-deals-banner-wrapper .color-swatch-hot")
    .forEach(function (el) {
      el.click();
    });
  // If sizes wrapper
  if (hasSizeSelector) {
    let currentSize = false;
    const selects = target.querySelector(".product-unit__sizes");
    const sizesContainer = selects.querySelector(".sizes-container");
    const component = target.querySelector(".product-unit__select--seleted");
    const atcBtn = target.querySelector(".product-unit__button");
    const sizeInput = target.querySelector(
      ".product-unit--quickadd .product-unit__size-component input[type=checkbox]"
    );

    if (window.innerWidth < 900) {
      if (
        selectSizeItems.innerHTML.includes("Clear Luggage Cover") ||
        selectSizeItems.innerHTML.includes("Padded Laptop Sleeve")
      ) {
        if (target.querySelector(".button-msg-add")) {
          target.querySelector(".button-msg-add").textContent = "Select Size";
        }
      }
    }

    for (const size in sizes) {
      if (size == "_count") continue;

      let el = document.createElement("a");
      el.setAttribute("href", "#");
      el.classList.add("size-swatch");
      el.classList.add("size-" + size);
      el.setAttribute("title", sizes[size].title);
      el.setAttribute("data-title", size);
      el.value = size;
      el.setAttribute("data-first-variant-id", sizes[size].first_variant_id);

      if (
        target
          .querySelector(".product-unit__select--seleted")
          .innerHTML.trim() == ""
      ) {
        el.classList.add("selected");
        target.querySelector(
          ".product-unit__select--seleted"
        ).innerHTML = `<span>${sizes[size].title}</span> <span>$${sizes[size].first_variant_price / 100
          }</span>`;
      }

      if (sizes[size].available === false)
        el.classList.add("product-option--na");

      if (sizes[size].selected === true) {
        el.classList.add("size-swatch--active");
        currentSize = sizes[size].title;
        if (!variantAutoSelected) el.classList.add("size-swatch--first");
      }

      if (sizes[size].available === false && sizes[size].selected === true)
        target.classList.add("product-unit--na");
      el.innerHTML = `<span>${sizes[size].title}</span> <span>${formatPrice(sizes[size].first_variant_price / 100)
        }</span>`;

      sizesContainer.appendChild(el);
    }
    if (window.innerWidth < 900) {
      const buttonTarget = target.querySelector(".product-unit__button");
      target.querySelector(".button--add-to-cart").classList.add("disabled");

      // options enabled
      buttonTarget.addEventListener("mouseover", (e) => {
        component.classList.add("hovered");
        target.querySelector(".button-msg-add").textContent = "Add to Bag";
        setTimeout(() => target.querySelector(".button--add-to-cart")?.classList.remove("disabled"), 300)
      });

      // options disabled
      buttonTarget.addEventListener("mouseout", (e) => {
        target.querySelector(".button-msg-add").textContent = "Select Size";
        setTimeout(() => target.querySelector(".button--add-to-cart")?.classList.add("disabled"), 300)
      });

      component.addEventListener("click", (e) => {
        component.classList.toggle("focused");
      });

      const sizeSwatches = target.querySelectorAll(".size-swatch");
      sizeSwatches.forEach((sizeSwatch) =>
        sizeSwatch.addEventListener("click", (e) => {
          component.classList.remove("focused");
        })
      );
    } else {
      const checkSelected = target.querySelector(
        ".product-unit--quickadd .product-unit__size-component label"
      );
      target.addEventListener("mouseover", (e) => {
        component.classList.add("hovered");
      });
      const checkboxes = document.querySelectorAll(
        ".product-unit--quickadd .product-unit__size-component input"
      );

      checkboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", (e) => {
          if (e.target.checked) {
            checkboxes.forEach((otherCheckbox) => {
              if (otherCheckbox !== e.target) {
                otherCheckbox.checked = false;
              }
            });
          }
        });
      });
    }
  }

  if (isProductUnit && currentColor) {
    let colorValue = document.createElement("div");
    colorValue.classList.add("color-swatch__value");
    colorValue.innerHTML = currentColor.toLowerCase();

    swatches?.appendChild(colorValue);

    // select first four swatches and set attribute to aria-hidden="false", other swatches set to aria-hidden="true"
    if (swatches) {
      let swatchesChildren = swatches.children;
      setTimeout(() => {
        for (let i = 0; i < swatchesChildren.length; i++) {
          if (i <= 4 && i !== 1) {
            swatchesChildren[i].setAttribute("tabindex", "0");
          } else {
            swatchesChildren[i].setAttribute("aria-hidden", "true");
            swatchesChildren[i].setAttribute("tabindex", "-1");
          }
        }
      }, 1000);
    }
  }

  const sliderWrapper = swatches?.parentNode;
  if (swatches) {
    swatches.classList.add("slider");
    const prevBtnAll = `<button class="round-icon slider__control slider__control--prev round-icon--prev" aria-label="Previous slide" title="Previous"></button>`;
    const nextBtnAll = `<button class="round-icon slider__control slider__control--next round-icon--next" aria-label="Next slide" title="Next"></button>`;
    sliderWrapper.setAttribute("data-slide", 4);
    sliderWrapper.setAttribute("data-slide-mob", 3);
    sliderWrapper.innerHTML += `<button class="round-icon slider__control slider__control--prev round-icon--prev" title="Previous"></button><button class="round-icon slider__control slider__control--next round-icon--next" title="Next"></button>`;
    sliderWrapper.classList.add("slider__wrapper", "slider__wrapper--start");
  }

  if (!allColors) {
    if (colors._count == settings.swatchesLimit + 1) {
      const swatchesContainer = target.querySelector(
        ".product-unit__swatches-container"
      );

      swatchesContainer.style.setProperty(
        "--product-unit-sw-limit",
        settings.swatchesLimit + 1
      );
    } else if (colors._count > settings.swatchesLimit + 1) {
      const swatchesContainer = target.querySelector(
        ".product-unit__swatches-container"
      );

      // let extra_colors = document.createElement("a");
      // extra_colors.classList.add("extra-colors");
      // extra_colors.setAttribute("href", `${shopUrl}/products/${handle}`);
      // extra_colors.innerHTML = "+" + (colors._count - settings.swatchesLimit);

      // swatchesContainer.appendChild(extra_colors);
    }
  }
  /* Join Waitlist label - update URL */
  const colorSwatches = target.querySelectorAll(
    ".product-unit__swatches .color-swatch"
  );



  [].map.call(colorSwatches, (colorSwatch) => {
    colorSwatch.addEventListener("click", (e) => {
      const clickedSwatch = e.target;

      // TEMP disable california check userRegionCode === "CA"
      if (calpak.userRegionCode === "OFFLINE") {
        // console.log('----------set product data ---------', calpak.userRegionCode)
        const sku = clickedSwatch.getAttribute("data-sku");
        if (calpak.hideSkusCalifornia?.includes(sku?.toUpperCase())) {
          const productUnit = clickedSwatch.closest(".product-unit");
          if (productUnit) {
            clickedSwatch.classList.add("product-option--na-california");
            setTimeout(() => {
              productUnit.classList.add("product-unit--na");
              productUnit.classList.add("product-unit--jw");
            }, 100);
          }
        }
      }

      if (clickedSwatch.classList.contains("product-option--na")) {
        const swatchUrl = clickedSwatch.getAttribute("href");
        const labelWaitlist = target.querySelector(
          ".product-label.product-label--na a"
        );

        if (labelWaitlist) {
          labelWaitlist.setAttribute("href", swatchUrl);
        }
      }
    });
  });

  const activeSwatch = target.querySelector(
    ".product-unit__swatches .color-swatch.color-swatch--active"
  );
  if(activeSwatch)
    activeSwatch.click();

  // Process current variant unless it's a breakdown product unit.
  if (isProductUnit && swatches) {
    setTimeout(async () => {
      calpak.variantUpdateProcess(target);
    }, 10)
  }

  // Initiate the swatches slider for each product unit.
  if (typeof sliderWrapper != 'undefined' && sliderWrapper != null) {
    setTimeout(async () => {
      calpak.checkSlider(sliderWrapper.querySelector(".slider"));
    }, 20)
  }

  calpak.adaColorSwatches(target, colorSwatches);
}
calpak.setProductData = setProductData

const activateProductUnit = async function(target) {
  if (target.classList.contains("product-unit--loaded")) {
    return;
  }
  const handle = target.getAttribute("data-handle");

  // if (window.debug) console.log("Init product", handle);

  // https://collect.js.org/api/where.html
  const product = calpak.products.where('handle', handle).first();

  setProductData(
      product,
      target,
      target.getAttribute("data-variant"),
      target.getAttribute("data-init-1")
  );
  [...target.querySelectorAll(".splash")].map((splash) =>
      splash.classList.remove("splash")
  );
  target.classList.add("product-unit--loaded");
  target.removeAttribute("tabindex");
  target.removeAttribute("aria-hidden");
  if (target.querySelector(".quick-view__link"))
    target
        .querySelector(".quick-view__link")
        .setAttribute("tabindex", "0");
  target
      .querySelector(".product-unit__image.product-link")
      ?.setAttribute("tabindex", "0");
  [...target.querySelectorAll(".color-swatch")].map((swatch) => {
    swatch.setAttribute("tabindex", "0");
    swatch.removeAttribute("aria-hidden");
  });
  // if (window.debug) console.log("Done product", handle);

}
calpak.activateProductUnit = activateProductUnit

const closeAllDropdowns = function() {
  const openDropdowns = document.querySelectorAll(
    ".site-header__dropdown--active"
  );
  if (openDropdowns.length > 0)
    openDropdowns.forEach((openDropdown) =>
      openDropdown.classList.remove("site-header__dropdown--active")
    );
}
calpak.closeAllDropdowns = closeAllDropdowns

function setProductUnitSwatchesCount() {
  const productUnitColorsAll = document.querySelectorAll(
    ".product-unit__colors--all .product-unit__swatches-container"
  );
  productUnitColorsAll.forEach((productUnitColors) => {
    const colorSwatch = productUnitColors.querySelector(".color-swatch");
    if (!colorSwatch) return;

    const prnt = productUnitColors.parentNode;
    productUnitColors.style.setProperty(
      "--fits",
      Math.floor(prnt.offsetWidth / colorSwatch.offsetWidth)
    );
  });
}



window.addEventListener("click", async (e) => {
  if (e.target.classList.contains("product-unit__select--seleted")) {
    [
      ...document.querySelectorAll(
        ".product-unit__size-component input:checked"
      ),
    ].map((focused) => (focused.checked = false));
    [
      ...document.querySelectorAll(
        ".product-unit__size-component label.hovered"
      ),
    ].map((focused) =>
      focused !== e.target ? focused.classList.remove("hovered") : null
    );
    [
      ...document.querySelectorAll(
        ".product-unit__size-component label.focused"
      ),
    ].map((focused) =>
      focused !== e.target ? focused.classList.remove("focused") : null
    );
  }

  if (e.target.classList.contains("color-swatch")) {
    e.preventDefault();
    const actives = e.target
      .closest(".swatches-container")
      .querySelectorAll(".color-swatch--active");
    actives.forEach((active) => {
      active.classList.remove("color-swatch--active");
      active.setAttribute("aria-checked", "false");
    });
    e.target.classList.add("color-swatch--active");
    if (
      e.target
        .closest(".product-unit__swatches")
        ?.classList.contains("product-active_unit__swatches")
    ) {
      var click_class = e.target.getAttribute("class");
      var click_variant = e.target.getAttribute("aria-label").toLowerCase();

      e.target
        .closest(".product-unit__colors")
        .querySelector(".product-unit__colors-text span").innerHTML =
        click_variant;
      e.target
        .closest(".product-unit__colors")
        .querySelector(".product-unit__colors-text a")
        .removeAttribute("class");
      e.target
        .closest(".product-unit__colors")
        .querySelector(".product-unit__colors-text a").className =
        click_class + " active--color-swatch color-swatch--first";
      if (
        e.target
          .closest(".product-unit__colors")
          .querySelector(".product-unit__colors-text a img")
      ) {
        e.target
          .closest(".product-unit__colors")
          .querySelector(".product-unit__colors-text a img")
          .remove();
      }
      if (e.target.children.length) {
        var click_img = e.target.querySelector("img").cloneNode(true);
        e.target
          .closest(".product-unit__colors")
          .querySelector(".product-unit__colors-text a")
          .appendChild(click_img);
      }
    }
    if (e.target.closest(".product-card")?.querySelector(".product-unit__image")) {
      // const productImageContainer = e.target.closest(".product-card").querySelector(".product-unit__image")
      // const productTitle = e.target.getAttribute("data-product-title");
      
      calpak.variantUpdateProductCard(e.target);
      return;
    }

    if (e.target.closest(".product-card")?.querySelector(".js-flickity")) {
      calpak.variantUpdateProductCard(e.target, true);
      return;
    }

    setTimeout(() => {
      calpak.variantUpdateProcess(e.target);
    }, 0);
    

    setTimeout(() => {
      const productCard = e.target.closest(".product-card");
      if (productCard) {
        const href = e.target.getAttribute("href");
        const personalizeBtn = productCard.querySelector(".personalize-button a");
        const personalizeLabel = productCard.querySelector(".personalize-label a");
        if (personalizeBtn && href) {
          personalizeBtn.setAttribute("href", `${href}/?openPersonalization=true`);
        }
        if (personalizeLabel && href) {
          personalizeLabel.setAttribute("href", `${href}/?openPersonalization=true`);
        }
      }

      calpak.productNewBadges(e.target, ".product-card");
      e.target.setAttribute("aria-checked", "true");

    // TODO Refactor!!
    // Update the newer .product-card images
    }, 0);

  } else if (e.target.classList.contains("product-option")) {
    e.preventDefault();

    const actives = e.target
      .closest(".pdp__variant-buttons")
      .querySelectorAll(".product-option--selected");
    actives.forEach((active) =>
      active.classList.remove("product-option--selected")
    );
    e.target.classList.add("product-option--selected");

    requestAnimationFrame(() => {
      calpak.variantUpdateProcess(e.target);
    });
  } else if (e.target.classList.contains("button--add-to-cart")) {
    e.preventDefault();
    let variant_id = false;
    let mod = {
      final: false,
      preorder: false,
    };

    // TODO refactor
    // PRODUCT CARDS, PRODUCT UNITS -> calpak.addToCart
    // get the variant id from either the .product-unit selected option, or the newer .product-card active swatch
    let prnt = e.target.closest(".product-unit, .product-unit-lite");

    if (prnt.classList.contains("product-unit--na")){
      window.location.href = prnt.querySelector(".join-waitlist").getAttribute("href");
      return false;
    }

    if (!prnt.classList.contains("product-unit--jw")) {
      if ((prnt && prnt.classList.contains("product-card")) || 
          (prnt && !prnt.classList.contains("product-card"))) {
        prnt.classList.add("adding-to-cart");
      }
    }

    requestAnimationFrame(() => {
      if (!prnt.classList.contains("product-unit--jw")) {
        if (prnt && prnt.classList.contains("product-card")) {
          const activeSwatch = prnt.querySelector(".color-swatch--active")
          variant_id = activeSwatch.getAttribute("data-variant-id")
          mod.final = activeSwatch.hasAttribute("data-final-sale")
          mod.truefinal = activeSwatch.hasAttribute("data-true-final-sale")
          mod.preorder = activeSwatch.getAttribute("data-preorder")
          // console.log(prnt)
        } else if (prnt && !prnt.classList.contains("product-card")) {
          const select = prnt.querySelector(".variant-select");
          variant_id = select.value;
          mod.final = select.options[select.selectedIndex].hasAttribute("data-final-sale");
          mod.truefinal = select.options[select.selectedIndex].hasAttribute("data-true-final-sale");
          mod.preorder = select.options[select.selectedIndex].getAttribute("data-preorder");
        } else {
          variant_id = e.target.getAttribute("data-id");
          mod.final = e.target.hasAttribute("data-final");
          mod.preorder = e.target.getAttribute("data-preorder");
        }
        if (!variant_id) return;

        // if (typeof openCart == "undefined") await activateCart();
        let properties = {};
        if(prnt.dataset.holidayGift == "true"){
          properties["_holiday_gift"] = true
        }
        calpak.addToCart(
          variant_id,
          1,
          (data) => {
            calpak.updateCart(data);

            if (!window.abtestvariant) {
              calpak.openCart(e.target);
            } else {
              const titleContainer = prnt.querySelector(
                ".product-unit__main-content"
              );
              const title =
                titleContainer.querySelector(".product-link").innerHTML;
              const colorContainer = prnt.querySelector(
                ".product-unit__swatches"
              );
              const color = colorContainer
                .querySelector(".color-swatch--active")
                .getAttribute("title");
              const imgContainer = prnt.querySelector(".product-unit__image");
              const img = imgContainer
                .querySelector(`img:not(.img-hover)`)
                .cloneNode(true);

              openPopUp(title, color, img);
            }

            if (prnt && prnt.classList.contains("adding-to-cart")) {
              prnt.classList.add("added-to-cart");

              setTimeout(() => {
                prnt.classList.remove("added-to-cart");
              }, 3000);
            }
          },
          () => {
            if (prnt) prnt.classList.remove("adding-to-cart");
          },
          mod.final,
          mod.truefinal,
          mod.preorder,
          false,
          false,
          false,
          false,
          false,
          false,
          properties
        );
      } else {
        let link = prnt.querySelector(".join-waitlist").getAttribute("href");
        window.location.href = link;
      }
    });
  }
  
   setTimeout(() => {
     closeAllDropdowns();
     const openNotifications = document.querySelector(
       ".notifications-popup--active"
     );
     if (openNotifications)
       openNotifications.classList.remove("notifications-popup--active");
   }, 0);
});


function activateVideoContainer(video) {
  const url = video.getAttribute("data-video");

  if (!video.classList.contains("video-iframe-container--loaded")) {
    if (!video.classList.contains("video-iframe-container--contain")) {
      const vimeoId = video.getAttribute("data-vimeo-id");

      fetch(
        `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(
          `https://vimeo.com/${vimeoId}`
        )}`,
        {
          method: "GET",
          cache: "no-cache",
          mode: "cors",
        }
      )
        .then((response) => response.json())
        .then((response) => {
          let videos = document.querySelectorAll(
            `.video-iframe-container[data-vimeo-id="${vimeoId}"]`
          );
          videos.forEach((video) => {
            video.style.setProperty(
              "--ratio",
              `${response.width} / ${response.height}`
            );
            if (video.closest(".video-slider__slide")) {
              video.parentNode.style.padding = "0";
              video.parentNode.style.aspectRatio = `${response.width} / ${response.height}`;
            }
          });
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
    if (window.product && window.product.title) {
      var videoTitleIframe = window.product.title + " product video";
    } else {
      var videoTitleIframe = "Product video";
    }
    video.innerHTML = `<iframe title="${videoTitleIframe}" allow="autoplay; fullscreen" allowfullscreen="" width="100%" height="100%" loading="lazy" frameborder="0" src="${url}"></iframe>`;
    video.classList.add("video-iframe-container--loaded");
  }
}

const quickViewClick = async function(e) {
  e.preventDefault();
  let variant = false;
  if (e.target.parentElement.classList.contains("quick-view__link")) {
    calpak.quickViewTriggerElement = e.target.parentElement;
  } else {
    calpak.quickViewTriggerElement = e.target;
  }
  const productUnit = this.closest(".product-unit");
  if (productUnit) {
    let variantSelect = productUnit.querySelector(".variant-select");
    if (variantSelect) variant = variantSelect.value;
  }
  calpak.closeCart()
  calpak.getQuickView(this.getAttribute("href"), variant);
}
calpak.quickViewClick = quickViewClick

let productUnitsObserver = false;
let videoObserver = false;

productUnitsObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          // TODO
          activateProductUnit(entry.target, false);
          productUnitsObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.01, rootMargin: "0px" }
);
calpak.productUnitsObserver = productUnitsObserver

videoObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          activateVideoContainer(entry.target);
          videoObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0, rootMargin: "0px" }
);
calpak.videoObserver = videoObserver

// TODO add all initialization functions on this loadCalpak function
const loadCalpak = async () => {
  /**
   * "calpak:loaded" means that the DOM is parsed and the product catalog is ready at calpak.products
   * https://collect.js.org/api/where.html
   */
  // load deferred scripts that require calpak:ready
  await calpak.loadScript(window.scripts.deferred)

  window.calpak.timers.calpakLoaded = performance.now().toFixed(0)
  calpak.loaded = true

  document.dispatchEvent(new Event("calpak:loaded"))
  // console.log('calpak:loaded');
}

window.addEventListener("DOMContentLoaded", () => {
  window.calpak.domLoaded = true
  window.calpak.timers.domLoaded = performance.now().toFixed(0)
})

const checkIfDOMReady = async () => {
  if (calpak.domLoaded) {
    loadCalpak();
  } else {
    setTimeout(() => checkIfDOMReady(), 100);
  }
}
// product catalog loaded, now check if DOM is ready to load calpak
document.addEventListener('products:loaded', async () => {
  window.calpak.timers.productsLoadedCheckIfDomReady = performance.now().toFixed(0)
  checkIfDOMReady()
})

window.addEventListener("load", async() => {
  window.calpak.timers.windowLoaded = performance.now().toFixed(0)
  // console.log(`timer window:load - ${window.calpak.timers.windowLoaded - window.calpak.timers.start} ms`)
})

document.addEventListener("calpak:loaded", () => {
  const calpakTimers = window.calpak.timers
  // console.log(`timer DOM parsed - ${calpakTimers.domParsed - calpakTimers.start} ms`)
  // console.log(`timer window:DOMContentLoaded - ${calpakTimers.domLoaded - calpakTimers.start} ms`)
  // console.log(`timer window:load - ${calpakTimers.windowLoaded - calpakTimers.start} ms`)
  // console.log(`timer products:loaded - ${calpakTimers.productsLoaded - calpakTimers.start} ms`)
  // console.log(`timer checkIfDOMReady delay - ${ calpakTimers.productsLoaded - calpakTimers.productsLoadedCheckIfDomReady} ms`)
  // console.log(`timer calpak:loaded - ${calpakTimers.calpakLoaded - calpakTimers.start} ms`)
  // console.log(`timer calpak:ready - ${calpakTimers.deferredLoaded - calpakTimers.start} ms`)
});

/**
 * TODO Add initialization functions here or listen for document "calpak:ready" event
 * `calpak:ready` event when product cache is available,
 * `calpak:loaded` event when deferred scripts loaded
 * Use `calpak:ready` if you need all scripts, DOM, and product cache to be available.
 */
document.addEventListener("calpak:loaded", () => {

  // initialize product-units in main section, not nav or cart
  const productUnits = document.querySelectorAll("#MainContent .product-unit.activate-js");
  // console.log('------------- productUnits.length -----------')
  // console.log(productUnits.length)
  for (const productUnit of productUnits) {
    // TODO very costly function, setting timeouts to give main thread a break, otherwise the page will freeze
    setTimeout(() => activateProductUnit(productUnit, false), 10)
    // setTimeout(() => productUnitsObserver.observe(productUnit), 10);
  }

  // initialize product-units in nav and cart with observer
  const productUnitsHeader = document.querySelectorAll(".product-unit.activate-js:not(#MainContent .product-unit.activate-js)");
  // console.log('------------- productUnitsHeader.length -----------')
  // console.log(productUnitsHeader.length)
  for (const productUnit of productUnitsHeader) {
    setTimeout(() => productUnitsObserver.observe(productUnit), 10)
    // setTimeout(() => activateProductUnit(productUnit, false), 10)
  }



})

// TODO timer for countdown banner, refactor to not always fire if not need to?
setInterval(() => updateTimeouts(), 1000);


document.addEventListener("calpak:loaded", () => {
  const videos = document.querySelectorAll(".video-iframe-container");
  videos.forEach((video) => videoObserver.observe(video));

  let quickViewLinks = document.querySelectorAll(".quick-view__link");
  [...quickViewLinks].map(function (quickViewLink) {
    quickViewLink.addEventListener("click", quickViewClick);
  });

  const subcategoryActivators = document.querySelectorAll(
      ".filter__collections .filter__collection"
  );
  [...subcategoryActivators].map(function (subcategoryActivator) {
    subcategoryActivator.addEventListener("click", function (e) {
      setTimeout(() => {
        let quickViewLinksDynamic =
            document.querySelectorAll(".quick-view__link");
        [...quickViewLinksDynamic].map(function (quickViewLink) {
          quickViewLink.addEventListener("click", quickViewClick);
        });
      }, 25);
    });
  });

  const footerLinks = document.querySelectorAll(".footer__widget-title");
  footerLinks.forEach((footerLink) =>
      footerLink.addEventListener("click", (e) =>
          e.target.classList.toggle("footer__widget-title--active")
      )
  );

  ///////////////////////// CART ///////////////////////////
  const bagLink = document.querySelectorAll(".open-cart-link");
  bagLink.forEach(function (element) {
    element.addEventListener("click", async function (e) {
      e.preventDefault();

      // if (typeof openCart == "undefined") await activateCart();
      calpak.openCart(e.target);
      document.querySelector(".close-button.close-button--cart").focus();




    });
  });

});

///////////////////////// TIMERS ///////////////////////////
async function updateTimeouts() {
  // memorial countdown timer is handled somewhere else -_-
  let countdown_ticks = document.querySelectorAll(".countdown-timer:not(.memorial-countdown-timer)");
  countdown_ticks.forEach(function (element) {
    element.style.display = "inline-flex";
  });
  for (let i = 0; i < countdown_ticks.length; i++) {
    let time_left = parseInt(countdown_ticks[i].getAttribute("data-time"));
    let time_end = parseInt(countdown_ticks[i].getAttribute("data-time-end"));
    let hide_day = countdown_ticks[i].getAttribute("data-hide-day");
    let show_full_text = countdown_ticks[i].getAttribute("show-date-time-text");

    if(!time_end){
      if (!time_left) {
        time_left = parseInt(countdown_ticks[i].getAttribute("data-time-left"));
        time_left--;
        countdown_ticks[i].setAttribute("data-time-left", time_left);
      } else {
        time_left--;
        countdown_ticks[i].setAttribute("data-time", time_left);
      }
    }
    else{
      let time_now = Math.floor(Date.now() / 1000);
      time_left = time_end - time_now;
    }

    let d = Math.floor(time_left / 86400);
    if(hide_day == "true")
      d = 0;
    let h = Math.floor(time_left / 3600);
    let m = Math.floor((time_left - h * 3600) / 60);
    let s = (time_left % 3600) % 60;

    if (m < 10) m = "0" + m;
    if (s < 10) s = "0" + s;

    if (hide_day == "true") {
      d = 0;
    }

    let timeLeftHtml = "";
    if (d > 0) {
      h -= 24 * d;
      if (h < 10) h = "0" + h;
      if(show_full_text == "true"){
        timeLeftHtml =
        '<div>' + d + '<span>Days</span></div><span>:</span><div>' + h + '<span>Hours</span></div><span>:</span><div>' + m + '<span>Minutes</span></div><span>:</span><div>' + s + '<span>Seconds</span></div>';
      } else {
        timeLeftHtml =
          "<span>" +
          d +
          "</span>:<span>" +
          h +
          "</span>:<span>" +
          m +
          "</span>:<span>" +
          s +
          "</span>";
      }
    } else {
      if (h < 10) h = "0" + h;
      if (show_full_text == "true") {
        timeLeftHtml =
        '<div>' + h + '<span>Hours</span></div><span>:</span><div>' + m + '<span>Minutes</span></div><span>:</span><div>' + s + '<span>Seconds</span></div>';
      } else {
        timeLeftHtml =
        "<span>" + h + "</span> : <span>" + m + "</span> : <span>" + s + "</span>";
      }
    }

    if (time_left == 0) {
      // console.log("timer end");
      document.location.href = document.location.href;
      countdown_ticks[i].setAttribute("data-time", "-1");
    }

    countdown_ticks[i].innerHTML = timeLeftHtml;
  }
}

const dailyTopBanner = document.querySelector(".daily-deals-banner--top");
if (dailyTopBanner) {
  document
    .querySelector(".daily-deals-banner--top")
    .addEventListener("click", function () {
      const element = document.querySelector(".section-daily-deals");
      element.scrollIntoView();
    });
}

const coporateButton = document.querySelector(".corporate-gifting-link");
if (coporateButton) {
  document
    .querySelector(".corporate-gifting-link")
    .addEventListener("click", function () {
      const element = document.querySelector(".html__section");
      element.scrollIntoView();
    });
}



function hasOtherValues(productContainer, value) {
  const select = productContainer.querySelector(".variant-select");
  if (!select) return false;

  return select.querySelector(
    `option[data-option2]:not([data-option2="${value}"])`
  )
    ? true
    : false;
}

const getProductOptionsList = function(productContainer, location = "pdp") {
  let options = [];
  let multipleSizes = false,
    disableMultiple = true;

  for (let i = 1; i <= 3; i++) {
    let selectorStr = `.pdp__variants [data-position="${i}"]`;
    if(location != "pdp"){
      selectorStr = `.product-unit__option[data-position="${i}"], .product-unit__colors[data-position="${i}"]`;
    }
    const optCont = productContainer.querySelector(selectorStr);
    if (optCont) {
      let value = false;
      if (optCont.classList.contains("product-unit__colors")) {
        let selectedOption = optCont.querySelector(".color-swatch--active");
        if (selectedOption) value = selectedOption.getAttribute("data-value");

        if (
          !disableMultiple &&
          i == 2 &&
          hasOtherValues(productContainer, value)
        )
          multipleSizes = true;
      } else if (optCont.classList.contains("product-unit__option")) {
        value = optCont.value;
        if (
          !disableMultiple &&
          i == 2 &&
          hasOtherValues(productContainer, value)
        )
          multipleSizes = true;
      } else if (optCont.classList.contains("pdp__variant-buttons")) {
        let selectedOption = optCont.querySelector(".product-option--selected");
        if (selectedOption) value = selectedOption.getAttribute("data-value");

        if (
          !disableMultiple &&
          i == 2 &&
          hasOtherValues(productContainer, value)
        )
          multipleSizes = true;
      } else if (optCont.classList.contains("pdp__variant-color")) {
        let selectedOption = optCont.querySelector(".color-swatch--active");
        if (selectedOption) value = selectedOption.getAttribute("data-value");

        if (
          !disableMultiple &&
          i == 2 &&
          hasOtherValues(productContainer, value)
        )
          multipleSizes = true;

        if (location == "pdp" && selectedOption) {
          const selVar = optCont.querySelector(".pdp__selected-variant");
          if (selVar) selVar.innerHTML = selectedOption.getAttribute("title");
        }
      }

      if (value === false || value === "false") continue;
      options.push(value);
    }
  }

  return [options, multipleSizes];
}
window.getProductOptionsList = getProductOptionsList

/* adding id to footer links */
window.addEventListener("load", () => {
  const footerLinks = document.querySelectorAll(
    ".footer__widget .list-menu__item"
  );
  [].map.call(footerLinks, (footerLink) => {
    let idString = footerLink.innerHTML
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/-$/, "")
      .replace(/^-/, "");
    footerLink.setAttribute("id", "menu-footer-" + idString);
  });
  /* hiding filter subcategories when inactive */
  if (window.location.pathname.includes("collections")) {
    setTimeout(function () {
      const subcategoryLinks = document.querySelectorAll(
        ".collection-categories__wrapper"
      );
      [].map.call(subcategoryLinks, (subcategoryLink) => {
        if (!subcategoryLink.classList.contains("slider__wrapper--loaded")) {
          subcategoryLink.style.display = "none";
        }
      });
    }, 500);
  }
});

document.addEventListener("calpak:loaded", function () {
  if (document.querySelector(".product-grid")) {
    // !!!
    const productGrids = document.querySelectorAll(".product-grid");

    //quick add function
    const loadQuickAdd = () => {
      // console.log('loadQuickAdd')
      // TODO WTH IS THIS?
      // document.querySelectorAll(".product-grid .quick-view__link").forEach(
          // (link) => link.classList.add("hide")
      // );
      // document.querySelectorAll(".product-grid").forEach(
      //     (grid) => grid.classList.add("product-grid--gap")
      // );
      // document.querySelectorAll(".product-grid .product-unit.activate-js").forEach(
      //     (productUnit) => {
          // productUnit.classList.add("product-unit--quickadd");
        // });

      let productUnits = [];
      productGrids.forEach(productGrid => {
        productUnits.push(...productGrid.querySelectorAll(".product-unit.activate-js"));
      })
      // console.log('loadQuickAdd productUnits length', productUnits.length)

      productUnits.forEach((productUnit) => {
        const colors = productUnit.querySelector(".product-unit__colors");

        if (colors) {
          // Find the quickadd colors container
          const colorsQuickAdd = productUnit.querySelector(
            ".product-unit__colors--quickadd"
          );

          if (colorsQuickAdd) {
            if (!colorsQuickAdd.contains(colors)) {
              colors.classList.add("product-unit__colors--all", "slide");

              colorsQuickAdd.appendChild(colors);
            }
          }
        }
      });

      // TODO check if this is needed anywhere, otherwise add product-unit__button--active if add to cart is on
      document.querySelectorAll(".product-grid .product-unit.activate-js .product-unit__button")
          .forEach((productUnitButton) => {
                productUnitButton.classList.add("product-unit__button--active")
              }
          );

      // Activate sliders TODO refactor
      // console.log(sliderWrapper.querySelector(".slider"));
      document.querySelectorAll(".product-grid .product-unit.activate-js .product-unit__swatches .slider, .product-grid .product-card .product-unit__swatches, .pdp__upsell .product-unit__swatches")
          .forEach((swatches) => {
            setTimeout(function () {
            calpak.checkSlider(swatches);
            }, 10);
          });

    };

    // NB TODO REFACTOR
    loadQuickAdd();
    // document.addEventListener("shopify:section:load", loadQuickAdd);
    // document.addEventListener("shopify:section:change", loadQuickAdd);
    // // document.addEventListener("page:load", loadQuickAdd);
    // document.addEventListener("page:change", loadQuickAdd);

    // const subcategoryLinks = document.querySelectorAll("a.filter__collection");
    // [].map.call(subcategoryLinks, (subcategoryLink) => {
    //   subcategoryLink.addEventListener("click", (e) => {
    //     setTimeout(function () {
    //       loadQuickAdd();
    //     }, 100);
    //   });
    // });
    const subcategoryLinks = document.querySelectorAll("a.filter__collection");
    [].map.call(subcategoryLinks, (subcategoryLink) => {
      subcategoryLink.addEventListener("click", (e) => {
        setTimeout(function () {
          loadQuickAdd();
        }, 300);
      });
    });
  }



  // On section-blog-text-product-feature, match the height of the text block to the image
  const blogText = document.querySelectorAll(
    ".shopify-section--blog-text-product-feature a.product-unit__image"
  );

  blogText.forEach((element) => {
    const matchTextHeight = window
      .getComputedStyle(element)
      .getPropertyValue("padding-top");
    const textBlocks = document.querySelectorAll(
      ".blog-text-product-feature__block-text"
    );

    textBlocks.forEach((textBlock) => {
      textBlock.style.height = matchTextHeight;
    });
  });

});

const getAllElementAtributes = (element) => {
  return element.getAttributeNames().map((attrName) => ({
    key: attrName,
    value: element.getAttribute(attrName),
  }));
};

const changeHtmlTagType = (element, htmlTag) => {
  let newElement = document.createElement(htmlTag);
  [...element.classList].map((oldClass) => {
    newElement.classList.add(oldClass);
  });

  [...getAllElementAtributes(element)].map(({ key, value }) => {
    newElement.setAttribute(key, value);
  });

  newElement.onclick = element.onclick;
  newElement.innerHTML = element.innerHTML;
  element.parentNode.appendChild(newElement);
  element.parentNode.removeChild(element);
  return newElement;
};

// ADA custom radio JS solution for keyboard navigation - Promo - Featured

function customRadioButtonsPromo() {
  const swatchesKeyContainerUnit = document.querySelectorAll(
    ".promo-collection .product-unit .product-unit__swatches"
  );
  [].map.call(swatchesKeyContainerUnit, (container) => {
    customRadioKeyboardNav(container);
  });
}

function customRadioButtonsCart() {
  const swatchesKeyContainerUnit = document.querySelectorAll(
    ".cart__body .product-unit .product-unit__swatches"
  );
  [].map.call(swatchesKeyContainerUnit, (container) => {
    customRadioKeyboardNav(container);
  });
}

function customRadioButtonsFeatured() {
  const swatchesKeyContainerUnit = document.querySelectorAll(
    ".featured-col__lists .product-unit .product-unit__swatches"
  );
  [].map.call(swatchesKeyContainerUnit, (container) => {
    customRadioKeyboardNav(container);
  });
}

function customRadioButtonsQuickAdd() {
  const swatchesKeyContainerUnit = document.querySelectorAll(
    ".product-unit__colors--quickadd"
  );
  [].map.call(swatchesKeyContainerUnit, (container) => {
    customRadioKeyboardNav(container);
  });
}

function customMenuTabDesk() {
  const swatchesKeyContainerUnit =
    document.querySelectorAll("#nav-header-bottom");
  [].map.call(swatchesKeyContainerUnit, (container) => {
    customTabKeyboardNav(container);
  });
}

document.addEventListener("calpak:loaded", () => {
  setTimeout(() => {
    customRadioButtonsPromo();
    customRadioButtonsFeatured();
    customRadioButtonsQuickAdd();
    customRadioButtonsCart();
  }, 500);
});
// End ADA custom radio JS solution for keyboard navigation - promo - Featured


document.addEventListener("calpak:loaded", () => {
  // not seeing this used anywhere

  // const navActivator = document.querySelector(".menu-popup__activator");
  // [].map.call(navActivator, (activator) => {
  //   activator.addEventListener("click", function (e) {
  //     setTimeout(() => {
  //       customRadioButtonsUnit();
  //     }, 500);
  //   });
  // });

  document.querySelector("#shop__mobile_tab")?.addEventListener("click", () => {
    document
      .querySelector("#shop__mobile_tab")
      .setAttribute("aria-selected", "true");
    document
      .querySelector("#discover__mobile_tab")
      ?.removeAttribute("aria-selected");
  });
  document
    .querySelector("#discover__mobile_tab")
    ?.addEventListener("click", () => {
      document
        .querySelector("#shop__mobile_tab")
        ?.removeAttribute("aria-selected");
      document
        .querySelector("#discover__mobile_tab")
        .setAttribute("aria-selected", "true");
    });

  const searchForm = document.getElementById("search-form");
  searchForm.addEventListener("focus", function () {
    searchForm.removeAttribute("aria-hidden");
  });
});


/* GENERAL RADIO BUTTONS KEYBOARD NAVIGATION */
const customRadioKeyboardNav = function customRadioKeyboardNav(container) {
  container.addEventListener("keyup", function (e) {
    let colorButtons = container.querySelectorAll(".color-swatch");
    [].map.call(colorButtons, (colorButton) => {
      colorButton.addEventListener("click", function (e) {
        selectColorButton(e.target);
      });
    });
    switch (e.key) {
      case "ArrowUp":
      case "ArrowLeft":
        e.preventDefault();
        selectPreviousColorButton(e.target);
        break;

      case "ArrowDown":
      case "ArrowRight":
        e.preventDefault();
        selectNextColorButton(e.target);
        break;

      case " ":
      case "":
      case "Enter":
        e.preventDefault();
        selectColorButton(e.target);
        e.target.click();
        break;
    }
    // secondary functions
    function selectPreviousColorButton(colorButton) {
      let index = Array.prototype.slice.call(colorButtons).indexOf(colorButton);

      if (index > 0) {
        selectColorButton(colorButtons[index - 1]);
      } else {
        selectColorButton(colorButtons[colorButtons.length - 1]);
      }
    }

    function selectNextColorButton(colorButton) {
      let index = Array.prototype.slice.call(colorButtons).indexOf(colorButton);

      if (index < colorButtons.length - 1) {
        selectColorButton(colorButtons[index + 1]);
      } else {
        selectColorButton(colorButtons[0]);
      }
    }

    function selectColorButton(colorButton) {
      // Deselect all other color buttons
      colorButtons.forEach(function (otherColorButton) {
        otherColorButton.setAttribute("tabindex", "-1");
        otherColorButton.setAttribute("aria-checked", false);
      });

      // Select the provided color button
      colorButton.setAttribute("tabindex", "0");
      colorButton.setAttribute("aria-checked", true);
      colorButton.focus();
    }
  });
}
calpak.customRadioKeyboardNav = customRadioKeyboardNav

function customTabKeyboardNav(container) {
  container.addEventListener("keyup", function (e) {
    let colorButtons = container.querySelectorAll("li > a");
    [].map.call(colorButtons, (colorButton) => {
      colorButton.addEventListener("click", function (e) {
        selectColorButton(e.target);
      });
    });

    switch (e.key) {
      case "ArrowUp":
      case "ArrowLeft":
        e.preventDefault();
        selectPreviousColorButton(e.target);
        break;

      case "ArrowDown":
      case "ArrowRight":
        e.preventDefault();
        selectNextColorButton(e.target);
        break;

      case " ":
      case "":
      case "Enter":
        e.preventDefault();
        selectColorButton(e.target);
        e.target.click();
        break;
    }
    // secondary functions
    function selectPreviousColorButton(colorButton) {
      let index = Array.prototype.slice.call(colorButtons).indexOf(colorButton);

      if (index > 0) {
        selectColorButton(colorButtons[index - 1]);
      } else {
        selectColorButton(colorButtons[colorButtons.length - 1]);
      }
    }

    function selectNextColorButton(colorButton) {
      let index = Array.prototype.slice.call(colorButtons).indexOf(colorButton);

      if (index < colorButtons.length - 1) {
        selectColorButton(colorButtons[index + 1]);
      } else {
        selectColorButton(colorButtons[0]);
      }
    }

    function selectColorButton(colorButton) {
      // Deselect all other color buttons
      colorButtons.forEach(function (otherColorButton) {
        otherColorButton.setAttribute("tabindex", "-1");
        otherColorButton.setAttribute("aria-checked", false);
      });

      // Select the provided color button
      colorButton.setAttribute("tabindex", "0");
      colorButton.setAttribute("aria-checked", true);
      colorButton.focus();
    }
  });
}

/* Code start for custom product size dropdown */
function updatePdpSizeDropdownLabelledBy(btn, optionId) {
  if (!btn?.classList.contains('js-pdp-size-dropdown') || !optionId) return;
  btn.setAttribute('aria-labelledby', `exp_label ${optionId}`);
}

var aria = aria || {};

aria.Listbox = function (listboxNode) {
  this.listboxNode = listboxNode;
  if (this.listboxNode !== null) {
    this.activeDescendant = this.listboxNode.getAttribute(
      "aria-activedescendant"
    );
    this.multiselectable = this.listboxNode.hasAttribute(
      "aria-multiselectable"
    );
  }
  this.moveUpDownEnabled = false;
  this.siblingList = null;
  this.startRangeIndex = 0;
  this.upButton = null;
  this.downButton = null;
  this.moveButton = null;
  this.keysSoFar = "";
  this.handleFocusChange = function () { };
  this.handleItemChange = function () { };
  this.registerEvents();
};

aria.Listbox.prototype.registerEvents = function () {
  if (this.listboxNode !== null) {
    this.listboxNode.addEventListener("focus", this.setupFocus.bind(this));
    this.listboxNode.addEventListener("keydown", this.checkKeyPress.bind(this));
    this.listboxNode.addEventListener("click", this.checkClickItem.bind(this));
    this.listboxNode.addEventListener("blur", this.reset.bind(this));
  }

  if (this.multiselectable) {
    this.listboxNode.addEventListener(
      "mousedown",
      this.checkMouseDown.bind(this)
    );
  }
};

aria.Listbox.prototype.reset = function () {
  let btn = document.querySelector('#exp_button');
  const defaultActiveDescendant = btn.getAttribute("data-default-activedescendant");
  const defaultTitle = btn.getAttribute("data-default-title");
  const defaultValue = btn.getAttribute("data-default-value");

  btn?.setAttribute("aria-activedescendant", defaultActiveDescendant);
  updatePdpSizeDropdownLabelledBy(btn, defaultActiveDescendant);

  const classList = Array.from(btn.classList);
  const listBox = Array.from(this.listboxNode.classList);
  const dropdownClassPrefix = 'dropdown-';
  const listboxClassPrefix = 'dropdownlist-';

  classList.forEach(className => {
    if (className.startsWith(dropdownClassPrefix)) {
      btn?.classList.remove(className);
    }
  });

  listBox.forEach(className => {
    if (className.startsWith(listboxClassPrefix)) {
      this.listboxNode.classList.remove(className);
    }
  });

  if (btn) {
    btn.classList.add(`${dropdownClassPrefix}${defaultValue}`);
    btn.classList.add('dropdown-box');
  }

  this.listboxNode.classList.add(`${listboxClassPrefix}${defaultValue}`);
  this.listboxNode.classList.add('dropdownlist_box');

  if (btn && !btn.classList.contains('js-pdp-size-dropdown')) {
    btn.innerHTML = defaultTitle;
  }

  this.listboxNode.querySelectorAll("li").forEach(function (item) {
    if(item.value != defaultValue){
      item.setAttribute("aria-selected", false);
      item.classList.remove("focused")
    }
  })
}

aria.Listbox.prototype.setupFocus = function () {
  if (this.activeDescendant) {
    return;
  }
};

aria.Listbox.prototype.focusFirstItem = function () {
  var firstItem = this.listboxNode.querySelector('[role="option"]');

  if (firstItem) {
    this.focusItem(firstItem);
  }
};

aria.Listbox.prototype.focusLastItem = function () {
  var itemList = this.listboxNode.querySelectorAll('[role="option"]');

  if (itemList.length) {
    this.focusItem(itemList[itemList.length - 1]);
  }
};

aria.Listbox.prototype.checkKeyPress = function (evt) {
  if (this.listboxNode.classList.contains("hidden")) return;
  var key = evt.which || evt.keyCode;
  var lastActiveId = this.activeDescendant;
  var allOptions = this.listboxNode.querySelectorAll('[role="option"]');
  var currentItem =
    document.getElementById(this.activeDescendant) || allOptions[0];
  var nextItem = currentItem;

  if (!currentItem) {
    return;
  }

  const btn = document.querySelector("#exp_button");

  switch (key) {
    case aria.KeyCode.PAGE_UP:
    case aria.KeyCode.PAGE_DOWN:
      if (this.moveUpDownEnabled) {
        evt.preventDefault();

        if (key === aria.KeyCode.PAGE_UP) {
          this.moveUpItems();
        } else {
          this.moveDownItems();
        }
      }

      break;
    case aria.KeyCode.UP:
    case aria.KeyCode.DOWN:
      if (!this.activeDescendant) {
        // focus first option if no option was previously focused, and perform no other actions
        this.focusItem(currentItem);
        break;
      }

      if (this.moveUpDownEnabled && evt.altKey) {
        evt.preventDefault();
        if (key === aria.KeyCode.UP) {
          this.moveUpItems();
        } else {
          this.moveDownItems();
        }
        return;
      }

      if (key === aria.KeyCode.UP) {
        nextItem = this.findPreviousOption(currentItem);
        if (!nextItem) {
          nextItem = allOptions[allOptions.length - 1];
        }
      } else {
        nextItem = this.findNextOption(currentItem);
        if (!nextItem) {
          nextItem = allOptions[0];
        }
      }

      if (nextItem && this.multiselectable && evt.shiftKey) {
        this.selectRange(this.startRangeIndex, nextItem);
      }

      if (nextItem) {
        this.focusItem(nextItem);
        evt.preventDefault();
      }

      break;
    case aria.KeyCode.HOME:
      evt.preventDefault();
      this.focusFirstItem();

      if (this.multiselectable && evt.shiftKey && evt.ctrlKey) {
        this.selectRange(this.startRangeIndex, 0);
      }
      break;
    case aria.KeyCode.END:
      evt.preventDefault();
      this.focusLastItem();

      if (this.multiselectable && evt.shiftKey && evt.ctrlKey) {
        this.selectRange(this.startRangeIndex, allOptions.length - 1);
      }
      break;
    case aria.KeyCode.SHIFT:
      this.startRangeIndex = this.getElementIndex(currentItem, allOptions);
      break;
    case aria.KeyCode.SPACE:
      evt.preventDefault();
      this.toggleSelectItem(nextItem);
      break;
    case aria.KeyCode.BACKSPACE:
    case aria.KeyCode.DELETE:
    case aria.KeyCode.RETURN:
      if (!this.moveButton) {
        return;
      }

      var keyshortcuts = this.moveButton.getAttribute("aria-keyshortcuts");
      if (key === aria.KeyCode.RETURN && keyshortcuts.indexOf("Enter") === -1) {
        return;
      }
      if (
        (key === aria.KeyCode.BACKSPACE || key === aria.KeyCode.DELETE) &&
        keyshortcuts.indexOf("Delete") === -1
      ) {
        return;
      }

      evt.preventDefault();

      var nextUnselected = nextItem.nextElementSibling;
      while (nextUnselected) {
        if (nextUnselected.getAttribute("aria-selected") != "true") {
          break;
        }
        nextUnselected = nextUnselected.nextElementSibling;
      }
      if (!nextUnselected) {
        nextUnselected = nextItem.previousElementSibling;
        while (nextUnselected) {
          if (nextUnselected.getAttribute("aria-selected") != "true") {
            break;
          }
          nextUnselected = nextUnselected.previousElementSibling;
        }
      }

      this.moveItems();

      if (!this.activeDescendant && nextUnselected) {
        this.focusItem(nextUnselected);
      }
      break;
    case 65:
      // handle control + A
      if (this.multiselectable && (evt.ctrlKey || evt.metaKey)) {
        evt.preventDefault();
        this.selectRange(0, allOptions.length - 1);
        break;
      }
    // fall through
    default:
      var itemToFocus = this.findItemToFocus(key);
      if (itemToFocus) {
        this.focusItem(itemToFocus);
      }
      break;
  }

  if (this.activeDescendant !== lastActiveId) {
    this.updateScroll();
  }
};

aria.Listbox.prototype.findItemToFocus = function (key) {
  var itemList = this.listboxNode.querySelectorAll('[role="option"]');
  var character = String.fromCharCode(key);
  var searchIndex = 0;

  if (!this.keysSoFar) {
    for (var i = 0; i < itemList.length; i++) {
      if (itemList[i].getAttribute("id") == this.activeDescendant) {
        searchIndex = i;
      }
    }
  }
  this.keysSoFar += character;
  this.clearKeysSoFarAfterDelay();

  var nextMatch = this.findMatchInRange(
    itemList,
    searchIndex + 1,
    itemList.length
  );
  if (!nextMatch) {
    nextMatch = this.findMatchInRange(itemList, 0, searchIndex);
  }
  return nextMatch;
};

/* Return the index of the passed element within the passed array, or null if not found */
aria.Listbox.prototype.getElementIndex = function (option, options) {
  var allOptions = Array.prototype.slice.call(options); // convert to array
  var optionIndex = allOptions.indexOf(option);

  return typeof optionIndex === "number" ? optionIndex : null;
};

/* Return the next listbox option, if it exists; otherwise, returns null */
aria.Listbox.prototype.findNextOption = function (currentOption) {
  var allOptions = Array.prototype.slice.call(
    this.listboxNode.querySelectorAll('[role="option"]')
  ); // get options array
  var currentOptionIndex = allOptions.indexOf(currentOption);
  var nextOption = null;

  // Find the next visible option
  for (var i = currentOptionIndex + 1; i < allOptions.length; i++) {
    if (!allOptions[i].classList.contains('sr-only')) {
      nextOption = allOptions[i];
      break;
    }
  }

  // If no next visible option is found, wrap around to the first visible option
  if (!nextOption) {
    for (var j = 0; j <= currentOptionIndex; j++) {
      if (!allOptions[j].classList.contains('sr-only')) {
        nextOption = allOptions[j];
        break;
      }
    }
  }

  return nextOption;
};

/* Return the previous listbox option, if it exists; otherwise, returns null */
aria.Listbox.prototype.findPreviousOption = function (currentOption) {
  var allOptions = Array.prototype.slice.call(
    this.listboxNode.querySelectorAll('[role="option"]')
  ); // get options array
  var currentOptionIndex = allOptions.indexOf(currentOption);
  var previousOption = null;

  for (var i = currentOptionIndex - 1; i >= 0; i--) {
    if (!allOptions[i].classList.contains("sr-only")) {
      previousOption = allOptions[i];
      break;
    }
  }

  if (!previousOption) {
    for (var j = allOptions.length - 1; j > currentOptionIndex; j--) {
      if (!allOptions[j].classList.contains("sr-only")) {
        previousOption = allOptions[j];
        break;
      }
    }
  }

  return previousOption;
};

aria.Listbox.prototype.clearKeysSoFarAfterDelay = function () {
  if (this.keyClear) {
    clearTimeout(this.keyClear);
    this.keyClear = null;
  }
  this.keyClear = setTimeout(
    function () {
      this.keysSoFar = "";
      this.keyClear = null;
    }.bind(this),
    500
  );
};

aria.Listbox.prototype.findMatchInRange = function (
  list,
  startIndex,
  endIndex
) {
  // Find the first item starting with the keysSoFar substring, searching in
  // the specified range of items
  for (var n = startIndex; n < endIndex; n++) {
    var label = list[n].innerText;
    if (label && label.toUpperCase().indexOf(this.keysSoFar) === 0) {
      return list[n];
    }
  }
  return null;
};

aria.Listbox.prototype.checkClickItem = function (evt) {
  if (evt.target.getAttribute("role") !== "option") {
    return;
  }

  this.focusItem(evt.target);
  this.toggleSelectItem(evt.target);
  this.updateScroll();

  if (this.multiselectable && evt.shiftKey) {
    this.selectRange(this.startRangeIndex, evt.target);
  }
};

aria.Listbox.prototype.checkMouseDown = function (evt) {
  if (
    this.multiselectable &&
    evt.shiftKey &&
    evt.target.getAttribute("role") === "option"
  ) {
    evt.preventDefault();
  }
};

aria.Listbox.prototype.toggleSelectItem = function (element) {
  if (this.multiselectable) {
    element.setAttribute(
      "aria-selected",
      element.getAttribute("aria-selected") === "true" ? "false" : "true"
    );

    this.updateMoveButton();
  }
};

aria.Listbox.prototype.defocusItem = function (element) {
  if (!element) {
    return;
  }
  if (!this.multiselectable) {
    element.setAttribute("aria-selected", "false");
  }
  element.classList.remove("focused");
};

aria.Listbox.prototype.focusItem = function (element) {
  // console.log(this.activeDescendant);
  this.defocusItem(document.getElementById(this.activeDescendant));

  if (!this.multiselectable) {
    element.setAttribute("aria-selected", "true");
  }

  let product_handle = element.getAttribute("value");
  const parentUlClass = element.parentNode.classList[1];
  let url = `/products/${product_handle}`;
  var variant_handle = element.getAttribute("data-producthandle");
  var quickView = document
    .querySelector("ul." + parentUlClass)
    .getAttribute("is-quickview");

  let keyboard = true;

  document.addEventListener("keydown", function () {
    keyboard = true;
  });

  document.addEventListener("click", () => {
    keyboard = false;
  });

  setTimeout(() => {
    let btn = document.querySelector('#exp_button');
    const focusedElement = document.querySelector('#exp_elem_list li.focused');
    const focusedElementValue = focusedElement ? focusedElement.getAttribute("value") : '';

    btn?.setAttribute("aria-activedescendant", this.activeDescendant);
    updatePdpSizeDropdownLabelledBy(btn, this.activeDescendant);

    const classList = Array.from(btn.classList);
    const listBox = Array.from(this.listboxNode.classList);
    const dropdownClassPrefix = 'dropdown-';
    const listboxClassPrefix = 'dropdownlist-';

    classList.forEach(className => {
      if (className.startsWith(dropdownClassPrefix)) {
        btn?.classList.remove(className);
      }
    });

    listBox.forEach(className => {
      if (className.startsWith(listboxClassPrefix)) {
        this.listboxNode.classList.remove(className);
      }
    });

    if (btn) {
      btn.classList.add(`${dropdownClassPrefix}${focusedElementValue}`);
      btn.classList.add('dropdown-box');
    }

    this.listboxNode.classList.add(`${listboxClassPrefix}${focusedElementValue}`);
    this.listboxNode.classList.add('dropdownlist_box');

    if (focusedElement && btn) {
      const itemTitle = focusedElement.getAttribute('data-prodtitle') || '';
      if (this.listboxNode.classList.contains('js-size-dropdown')) {
        btn.innerHTML = itemTitle;
      } else {
        let itemPrice = parseFloat(focusedElement.getAttribute('data-prod-price'));
        let itemComparePrice = parseFloat(focusedElement.getAttribute('data-prod-cprice'));
        if (itemPrice) {
          let formatedPrice = `<span class="sr-only">Current price: </span>${formatPrice(itemPrice / 100)}`;
          if (itemComparePrice) {
            formatedPrice = `<span class="sr-only">Original price: </span>&nbsp;-<s>${formatPrice(itemComparePrice / 100).trim()}</s>` + formatedPrice;
          }
          if (!itemComparePrice) {
            formatedPrice = `<span class="sr-only">Original price: </span>&nbsp;-&nbsp;${formatPrice(itemPrice / 100)}`;
          }
          btn.innerHTML = itemTitle + formatedPrice;
        } else {
          btn.innerHTML = itemTitle;
        }
      }
    }

    if (keyboard) {
      document.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          const focusedElement = document.querySelector('#exp_elem_list li.focused');
          quickView = document.querySelector("#exp_elem_list").getAttribute("is-quickview");

          if (focusedElement) {
            const currentProductHandle = focusedElement.getAttribute("value");
            const currentVariantHandle = focusedElement.getAttribute("data-producthandle");
            if (quickView === "false") {
              location.href = `/products/${currentProductHandle}/${currentVariantHandle}`;
            } else {
                setTimeout(() => {
                  calpak.getQuickView(`/products/${currentProductHandle}`, currentVariantHandle);
                }, 0);
              }
            }
        }
      });
    } else {
      if (quickView == "false") {
        location.href = url + "/" + variant_handle;
      } else {
        calpak.getQuickView(url, variant_handle);
      }
    }
  }, 100);

  element.classList.add("focused");

  if(!this.listboxNode.classList.contains("js-size-dropdown")) {
    this.listboxNode.setAttribute("aria-activedescendant", element.id);
  }
  this.activeDescendant = element.id;

  if (!this.multiselectable) {
    this.updateMoveButton();
  }

  this.checkUpDownButtons();
  this.handleFocusChange(element);
};

aria.Listbox.prototype.checkInRange = function (index, start, end) {
  var rangeStart = start < end ? start : end;
  var rangeEnd = start < end ? end : start;

  return index >= rangeStart && index <= rangeEnd;
};

aria.Listbox.prototype.selectRange = function (start, end) {
  // get start/end indices
  var allOptions = this.listboxNode.querySelectorAll('[role="option"]');
  var startIndex =
    typeof start === "number" ? start : this.getElementIndex(start, allOptions);
  var endIndex =
    typeof end === "number" ? end : this.getElementIndex(end, allOptions);

  for (var index = 0; index < allOptions.length; index++) {
    var selected = this.checkInRange(index, startIndex, endIndex);
    allOptions[index].setAttribute("aria-selected", selected + "");
  }

  this.updateMoveButton();
};

/**
 * Check for selected options and update moveButton, if applicable
 */
aria.Listbox.prototype.updateMoveButton = function () {
  if (!this.moveButton) {
    return;
  }

  if (this.listboxNode.querySelector('[aria-selected="true"]')) {
    this.moveButton.setAttribute("aria-disabled", "false");
  } else {
    this.moveButton.setAttribute("aria-disabled", "true");
  }
};

/**
 * Check if the selected option is in view, and scroll if not
 */
aria.Listbox.prototype.updateScroll = function () {
  var selectedOption = document.getElementById(this.activeDescendant);
  if (
    selectedOption &&
    this.listboxNode.scrollHeight > this.listboxNode.clientHeight
  ) {
    var scrollBottom =
      this.listboxNode.clientHeight + this.listboxNode.scrollTop;
    var elementBottom = selectedOption.offsetTop + selectedOption.offsetHeight;
    if (elementBottom > scrollBottom) {
      this.listboxNode.scrollTop =
        elementBottom - this.listboxNode.clientHeight;
    } else if (selectedOption.offsetTop < this.listboxNode.scrollTop) {
      this.listboxNode.scrollTop = selectedOption.offsetTop;
    }
  }
};

/**
 * @description
 *  Enable/disable the up/down arrows based on the activeDescendant.
 */
aria.Listbox.prototype.checkUpDownButtons = function () {
  var activeElement = document.getElementById(this.activeDescendant);

  if (!this.moveUpDownEnabled) {
    return;
  }

  if (!activeElement) {
    this.upButton.setAttribute("aria-disabled", "true");
    this.downButton.setAttribute("aria-disabled", "true");
    return;
  }

  if (this.upButton) {
    if (activeElement.previousElementSibling) {
      this.upButton.setAttribute("aria-disabled", false);
    } else {
      this.upButton.setAttribute("aria-disabled", "true");
    }
  }

  if (this.downButton) {
    if (activeElement.nextElementSibling) {
      this.downButton.setAttribute("aria-disabled", false);
    } else {
      this.downButton.setAttribute("aria-disabled", "true");
    }
  }
};

aria.Listbox.prototype.addItems = function (items) {
  if (!items || !items.length) {
    return;
  }

  items.forEach(
    function (item) {
      this.defocusItem(item);
      this.toggleSelectItem(item);
      this.listboxNode.append(item);
    }.bind(this)
  );

  if (!this.activeDescendant) {
    this.focusItem(items[0]);
  }

  this.handleItemChange("added", items);
};

aria.Listbox.prototype.deleteItems = function () {
  var itemsToDelete;

  if (this.multiselectable) {
    itemsToDelete = this.listboxNode.querySelectorAll('[aria-selected="true"]');
  } else if (this.activeDescendant) {
    itemsToDelete = [document.getElementById(this.activeDescendant)];
  }

  if (!itemsToDelete || !itemsToDelete.length) {
    return [];
  }

  itemsToDelete.forEach(
    function (item) {
      item.remove();

      if (item.id === this.activeDescendant) {
        this.clearActiveDescendant();
      }
    }.bind(this)
  );

  this.handleItemChange("removed", itemsToDelete);

  return itemsToDelete;
};

aria.Listbox.prototype.clearActiveDescendant = function () {
  this.activeDescendant = null;
  this.listboxNode.setAttribute("aria-activedescendant", null);

  this.updateMoveButton();
  this.checkUpDownButtons();
};

aria.Listbox.prototype.moveUpItems = function () {
  if (!this.activeDescendant) {
    return;
  }

  var currentItem = document.getElementById(this.activeDescendant);
  var previousItem = currentItem.previousElementSibling;

  if (previousItem) {
    this.listboxNode.insertBefore(currentItem, previousItem);
    this.handleItemChange("moved_up", [currentItem]);
  }

  this.checkUpDownButtons();
};

aria.Listbox.prototype.moveDownItems = function () {
  if (!this.activeDescendant) {
    return;
  }

  var currentItem = document.getElementById(this.activeDescendant);
  var nextItem = currentItem.nextElementSibling;

  if (nextItem) {
    this.listboxNode.insertBefore(nextItem, currentItem);
    this.handleItemChange("moved_down", [currentItem]);
  }

  this.checkUpDownButtons();
};

aria.Listbox.prototype.moveItems = function () {
  if (!this.siblingList) {
    return;
  }

  var itemsToMove = this.deleteItems();
  this.siblingList.addItems(itemsToMove);
};

aria.Listbox.prototype.enableMoveUpDown = function (upButton, downButton) {
  this.moveUpDownEnabled = true;
  this.upButton = upButton;
  this.downButton = downButton;
  upButton.addEventListener("click", this.moveUpItems.bind(this));
  downButton.addEventListener("click", this.moveDownItems.bind(this));
};

aria.Listbox.prototype.setupMove = function (button, siblingList) {
  this.siblingList = siblingList;
  this.moveButton = button;
  button.addEventListener("click", this.moveItems.bind(this));
};

aria.Listbox.prototype.setHandleItemChange = function (handlerFn) {
  this.handleItemChange = handlerFn;
};

aria.Listbox.prototype.setHandleFocusChange = function (focusChangeHandler) {
  this.handleFocusChange = focusChangeHandler;
};

("use strict");

window.addEventListener("load", function () {
  if (typeof window.product !== "undefined") {
    selectLoad(false, window.product.handle);
  }
});

const selectLoad = function selectLoad(createTypeSelectProductQuickView = false, product_handle) {
  let quickView = createTypeSelectProductQuickView;
  let producthandle = product_handle;
  if (product_handle) {
    if(quickView){
      var button = document.querySelector(".qv__body .dropdown-" + product_handle);
      var exListbox = new aria.Listbox(
        document.querySelector(".qv__body .dropdownlist-" + product_handle)
      );
      new aria.ListboxButton(button, exListbox, quickView, producthandle);
    }
    else{
      var button = document.querySelector(".dropdown-" + product_handle);
      var exListbox = new aria.Listbox(
        document.querySelector(".dropdownlist-" + product_handle)
      );
      new aria.ListboxButton(button, exListbox, quickView, producthandle);
    }
  } else {
    var button = document.querySelector(".dropdown-box");
    var exListbox = new aria.Listbox(
      document.querySelector(".dropdownlist_box")
    );
    new aria.ListboxButton(button, exListbox, quickView, producthandle);
  }
}
calpak.selectLoad = selectLoad

var aria = aria || {};

aria.ListboxButton = function (button, listbox, quickView, producthandle) {
  this.button = button;
  this.listbox = listbox;
  this.quickView = quickView;
  this.producthandle = producthandle;
  this.navigating = false;
  this.listboxOpen = false;
  this._onDocPointerDown = this._onDocPointerDown || this.onDocPointerDown.bind(this);
  this.registerEvents();
};

aria.ListboxButton.prototype.onDocPointerDown = function (e) {
  if (!this.listboxOpen) return;

  const node = this.listbox && this.listbox.listboxNode;
  const inside =
    (this.button && this.button.contains(e.target)) ||
    (node && node.contains(e.target));

  if (!inside) {
    this.hideListbox();
  }
};


aria.ListboxButton.prototype.registerEvents = function () {
  if (this.button) {
    this.button.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.toggleListbox();
    });
    this.button.addEventListener("blur", this.blurButton.bind(this));
    this.button.addEventListener("keydown", this.onButtonKeyDown.bind(this));
  }

  this.listbox.listboxNode?.addEventListener("blur", this.blurButton.bind(this));
  this.listbox.listboxNode?.addEventListener("keydown", this.checkHide.bind(this));
};

aria.ListboxButton.prototype.toggleListbox = function () {
  if (this.listboxOpen) {
    this.hideListbox();
  } else {
    this.showListbox();
  }
};

aria.ListboxButton.prototype.checkShow = function (evt) {
  var key = evt.which || evt.keyCode;

  switch (key) {
    case aria.KeyCode.UP:
    case aria.KeyCode.DOWN:
      evt.preventDefault();
      this.listbox.checkKeyPress(evt);
      let ul = document.querySelector("#exp_elem_list");
      if(ul) ul.setAttribute("is-quickview", this.quickView);
      this.showListbox();
      break;
    case aria.KeyCode.ENTER:
    case aria.KeyCode.SPACE:
      evt.preventDefault();
      this.showListbox();
      break;
  }
};

aria.ListboxButton.prototype.blurButton = function (evt) {
  if (evt.currentTarget == this.button) return;
  evt.preventDefault();
  if (this.listboxOpen) this.hideListbox();
  if (!this.navigating) this.listbox.reset();
};

aria.ListboxButton.prototype.onButtonKeyDown = function (evt) {
  const key = evt.key || evt.keyCode;

  if (key === "Tab" || key === aria.KeyCode.TAB) {
    if (this.listboxOpen) this.hideListbox();
    return;
  }

  if (key === "Escape" || key === aria.KeyCode.ESC) {
    if (this.listboxOpen) {
      evt.preventDefault();
      this.hideListbox();
      this.listbox.reset();
    }
    this.button.focus();
    return;
  }

  if (
    key === "Enter" || key === aria.KeyCode.RETURN ||
    key === " " || key === aria.KeyCode.SPACE
  ) {
    evt.preventDefault();
    if (!this.listboxOpen) this.showListbox();
    return;
  }

  if (
    key === "ArrowDown" || key === aria.KeyCode.DOWN ||
    key === "ArrowUp" || key === aria.KeyCode.UP
  ) {
    evt.preventDefault();
    if (!this.listboxOpen) this.showListbox();
    this.listbox.checkKeyPress(evt);
  }
};

aria.ListboxButton.prototype.checkHide = function (evt) {
  var key = evt.which || evt.keyCode;

  if (key === aria.KeyCode.TAB) {
    if (this.listboxOpen) this.hideListbox();
    return;
  }

  switch (key) {
    case aria.KeyCode.RETURN:
      evt.preventDefault();
      this.hideListbox();
      this.navigating = true;
      break;
    case aria.KeyCode.ESC:
      evt.preventDefault();
      this.hideListbox();
      this.listbox.reset();
      this.focusListBox();
      break;
  }
};


aria.ListboxButton.prototype.focusListBox = function () {
  this.button.focus();
};

// aria.ListboxButton.prototype.showListbox = function () {
//   aria.Utils.removeClass(this.listbox.listboxNode, "hidden");
//   this.button.setAttribute("aria-expanded", "true");
//   setTimeout(() => {
//     this.listbox.listboxNode.firstElementChild.focus();
//   }, 100);
//   let ul = document.querySelector("ul.dropdownlist-" + this.producthandle);
//   if(ul) ul.setAttribute("is-quickview", this.quickView);
// };

// aria.ListboxButton.prototype.hideListbox = function () {
//   aria.Utils.addClass(this.listbox.listboxNode, "hidden");
//   this.button.setAttribute("aria-expanded", "false");
// };

aria.ListboxButton.prototype.showListbox = function () {
  this.listboxOpen = true;

  const listboxNode = this.listbox.listboxNode;

  listboxNode.classList.remove("hidden");
  listboxNode.setAttribute("aria-hidden", "false");

  this.button.setAttribute("aria-expanded", "true");

  let ul = document.querySelector("ul.dropdownlist-" + this.producthandle);
  if (ul) ul.setAttribute("is-quickview", this.quickView);

  let activeOption =
    listboxNode.querySelector('[role="option"][aria-selected="true"]') ||
    listboxNode.querySelector('[role="option"]');

  if (activeOption) {
    this.listbox.activeDescendant = activeOption.id;
    this.button.setAttribute("aria-activedescendant", activeOption.id);

    listboxNode
      .querySelectorAll('[role="option"]')
      .forEach(opt => opt.classList.remove("focused"));

    activeOption.classList.add("focused");
  }

  if (!listboxNode.hasAttribute('tabindex')) {
    listboxNode.setAttribute('tabindex', '-1');
  }

  setTimeout(() => {
    listboxNode.focus();
  }, 10);

  document.addEventListener("pointerdown", this._onDocPointerDown, true);
};

aria.ListboxButton.prototype.hideListbox = function () {
  this.listboxOpen = false;

  document.removeEventListener("pointerdown", this._onDocPointerDown, true);

  this.listbox.listboxNode.classList.add("hidden");
  this.listbox.listboxNode.setAttribute("aria-hidden", "true");

  this.button.setAttribute("aria-expanded", "false");

  this.button.focus();
};


("use strict");
/**
 * @namespace aria
 */

var aria = aria || {};
aria.KeyCode = {
  BACKSPACE: 8,
  TAB: 9,
  RETURN: 13,
  SHIFT: 16,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46,
  ENTER: 13,
};

aria.Utils = aria.Utils || {};

// Polyfill src https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
aria.Utils.matches = function (element, selector) {
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.matchesSelector ||
      Element.prototype.mozMatchesSelector ||
      Element.prototype.msMatchesSelector ||
      Element.prototype.oMatchesSelector ||
      Element.prototype.webkitMatchesSelector ||
      function (s) {
        var matches = element.parentNode.querySelectorAll(s);
        var i = matches.length;
        while (--i >= 0 && matches.item(i) !== this) {
          // empty
        }
        return i > -1;
      };
  }

  return element.matches(selector);
};

aria.Utils.remove = function (item) {
  if (item.remove && typeof item.remove === "function") {
    return item.remove();
  }
  if (
    item.parentNode &&
    item.parentNode.removeChild &&
    typeof item.parentNode.removeChild === "function"
  ) {
    return item.parentNode.removeChild(item);
  }
  return false;
};

aria.Utils.isFocusable = function (element) {
  if (element.tabIndex < 0) {
    return false;
  }

  if (element.disabled) {
    return false;
  }

  switch (element.nodeName) {
    case "A":
      return !!element.href && element.rel != "ignore";
    case "INPUT":
      return element.type != "hidden";
    case "BUTTON":
    case "SELECT":
    case "TEXTAREA":
      return true;
    default:
      return false;
  }
};

aria.Utils.getAncestorBySelector = function (element, selector) {
  if (!aria.Utils.matches(element, selector + " " + element.tagName)) {
    // Element is not inside an element that matches selector
    return null;
  }

  // Move up the DOM tree until a parent matching the selector is found
  var currentNode = element;
  var ancestor = null;
  while (ancestor === null) {
    if (aria.Utils.matches(currentNode.parentNode, selector)) {
      ancestor = currentNode.parentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return ancestor;
};

aria.Utils.hasClass = function (element, className) {
  return new RegExp("(\\s|^)" + className + "(\\s|$)").test(element.className);
};

aria.Utils.addClass = function (element, className) {
  if (!aria.Utils.hasClass(element, className)) {
    element.className += " " + className;
  }
};

aria.Utils.removeClass = function (element, className) {
  var classRegex = new RegExp("(\\s|^)" + className + "(\\s|$)");
  element.className = element.className.replace(classRegex, " ").trim();
};

aria.Utils.bindMethods = function (object /* , ...methodNames */) {
  var methodNames = Array.prototype.slice.call(arguments, 1);
  methodNames.forEach(function (method) {
    object[method] = object[method].bind(object);
  });
};

/* Code end for custom product size dropdown */

const reloadStaticBlocks = () => {
  [...document.querySelectorAll(".static-block-script")]
    .map((script) => {
      let scriptInnerHtml = script.innerText;
      let scriptAttribute = script.getAttribute("data-function-name");
      let parent = script.parentNode;
      parent.removeChild(script);

      var newScriptTag = document.createElement("script");
      newScriptTag.innerText = scriptInnerHtml;
      newScriptTag.className = "static-block-script";
      newScriptTag.setAttribute("data-function-name", scriptAttribute);
      parent.appendChild(newScriptTag);
      return newScriptTag;
    })
    .map((script) => {
      //eval(script.getAttribute("data-function-name"))();
      window[script.getAttribute("data-function-name")]();
    });
};
calpak.reloadStaticBlocks = reloadStaticBlocks


if (
  document.querySelector(
    ".pdp__gallery-container .product-label--pushoutsale-main"
  )
) {
  var pushoutsaleMainDiv = document.querySelector(
    ".pdp__gallery-container .product-label--pushoutsale-main"
  );
  var badgeWrap = pushoutsaleMainDiv.querySelector(".badge-wrap");
  var text = badgeWrap.offsetWidth + 9;
  pushoutsaleMainDiv.style.width = text + "px";
}

// terms and conditions popup
function initializePopup() {
  const popupContainers = document.querySelectorAll(".terms-popup-container");
  const closebtn = document.querySelectorAll("#close-popup");
  const isShowPopup = document.querySelector(".term-condition-popup");
  const hashurl = document.querySelectorAll(".terms-popup-title");
  let scrollPosition = 0;

  let currentPopup = null;
  let lastFocusedElement = null;
  let focusableElements = [];
  let firstFocusableElement = null;
  let lastFocusableElement = null;

  const includeInFocus = ['a[href]', 'area', 'input', 'select', 'textarea', 'button', 'iframe', 'object', '[tabindex]'];
  const excludeFromFocus = ['[disabled]', '[hidden]', '[type="hidden"]', '[aria-hidden]', '[tabindex^="-"]'];
  const focusableSelectors = includeInFocus.map(element => {
    return `${element}:not(${excludeFromFocus.join(',')})`;
  });

  const closePopup = function () {
    if (isShowPopup) {
      isShowPopup.style.display = "none";
    }
    document.body.classList.remove("popup-open");
    document.body.classList.remove("terms-popup-overlay");
    document.documentElement.classList.remove("html-popup-open");
    const urlWithoutHash = window.location.href.split('#')[0];
    window.history.replaceState({}, document.title, urlWithoutHash);
    document.removeEventListener("click", closeOnOutsideClick);

    if(currentPopup) {
      currentPopup.removeEventListener("keydown", onPopupKeydown);
    }

    setTimeout(() => {
      document.body.style.overflow = "";
    }, 0);

    lastFocusedElement ? lastFocusedElement.focus() : document.body.focus();
  }

  closebtn.forEach((btn) => {
    btn.addEventListener("click", () => {
      closePopup();
    });
  });

  function OpenPopupOnHashChange() {
    let hashMatchFound = false;

    hashurl.forEach((hash) => {
      const hashText = "#" + hash.textContent.trim().toLocaleLowerCase().replaceAll(" ", "-");
      const currentHash = location.hash.trim().toLocaleLowerCase();
      if (currentHash === hashText) {
        openTermsPopup(hash.dataset.popupIndex);
        hashMatchFound = true;
      }
    });

    if (!hashMatchFound) {
      closePopup();
    }
  }

  OpenPopupOnHashChange();

  window.addEventListener("hashchange", () => {
    OpenPopupOnHashChange();
  });

  function openTermsPopup(index) {
    lastFocusedElement = document.activeElement;

    isShowPopup.style.display = "block";
    const targetPopup = document.querySelector(`.terms-popup-container.popup${index}`);
    if (targetPopup) {
      targetPopup.style.display = "block";
      document.body.classList.add("popup-open");
      document.body.classList.add("terms-popup-overlay");
      document.documentElement.classList.add("html-popup-open");
      trappingKeyboardFocus(targetPopup);

      popupContainers.forEach(container => {
        if (container !== targetPopup) {
          container.style.display = "none";
        }
      });
      scrollPosition = window.scrollY;
      document.addEventListener("click", closeOnOutsideClick);
    }
  }

  function closeOnOutsideClick(event) {
    const targetPopup = document.querySelector(`.terms-popup-container`);
    if (event.target.closest('.terms-popup-container')) {
      trappingKeyboardFocus(targetPopup);
    } else {
      closePopup();
    }
  }

  function onPopupKeydown(e) {
    if (e.key === "Escape") {
      e.preventDefault();
      closePopup();
    } else if (e.key === "Tab" && !e.shiftKey) {
      if (document.activeElement === lastFocusableElement) {
        e.preventDefault();
        firstFocusableElement.focus();
      }
    } else if (e.key === "Tab" && e.shiftKey) {
      if (document.activeElement === firstFocusableElement) {
        e.preventDefault();
        lastFocusableElement.focus();
      }
    }
  }

  function trappingKeyboardFocus(targetPopup) {
    focusableElements = Array.from(
      targetPopup.querySelectorAll(focusableSelectors.join(','))
    );

    firstFocusableElement = focusableElements[0];
    lastFocusableElement = focusableElements[focusableElements.length - 1];

    firstFocusableElement.focus();

    targetPopup.addEventListener("keydown", onPopupKeydown);
    currentPopup = targetPopup;
  }
}

// window.onload = () => {
//   initializePopup();
// };

document.addEventListener('calpak:loaded', function () {
  initializePopup();
})



// remove duplicate swatches
function removeDuplicateColors() {
  [1, 2, 3, 4, 5].forEach((_, index) => {
    const productCardSelector = `.hot-deals-banner-wrapper-school #product-card__${++index}`;
    const productCard = document.querySelectorAll(productCardSelector);
    productCard.forEach((card) => {
      const colors = card.querySelectorAll('.product-unit__swatches-container .product-unit__swatches a');
      const seenValues = new Set();
      colors.forEach((singleColor) => {
        let getColorValue = singleColor.getAttribute('data-value');
        if (getColorValue && !seenValues.has(getColorValue)) {
          seenValues.add(getColorValue);
        } else {
          singleColor.style.display = "none";
        }
      })
    });
  })
}

window.onload = () => {
  removeDuplicateColors();
  setTimeout(() => {
    removeDuplicateColors();
  }, 1000);
  setTimeout(() => {
    removeDuplicateColors();
  }, 2000);
}

/* dropdown on popup */
const dropdowns = document.querySelectorAll(".dropdown");

dropdowns.forEach((dropdown) => {
  const select = document.querySelector(".select");
  const caret = document.querySelector(".caret");
  const menu = document.querySelector(".menu");
  const options = document.querySelectorAll(".menu li");
  const selected = document.querySelector(".selected");
  document.addEventListener("DOMContentLoaded", function() {
    if (selected) {
      selected.innerHTML = selected.innerHTML.replace(/<br\s*\/?>/g, '');
    }
  });

  const firstOption = options[0];
  if (firstOption) {
    selected.innerText = firstOption.innerText;
    firstOption.classList.add("active");
  }
  select.addEventListener("click", () => {
    caret.classList.toggle("caret-rotate");
    menu.classList.toggle("menu-open");
  });

  options.forEach((option) => {
    option.addEventListener("click", () => {
      selected.classList.remove("placeholder");
      selected.innerText = option.innerText;
      caret.classList.remove("caret-rotate");
      menu.classList.remove("menu-open");
      options.forEach((option) => option.classList.remove("active"));
      option.classList.add("active");
      select.classList.add("active");
    });
  });
});
document.addEventListener("DOMContentLoaded", function() {
  var menuItems = document.querySelectorAll('.menu li');
  menuItems.forEach(function(item) {
    item.addEventListener('click', function() {
      var selectedCollection = this.textContent.trim();
      var contentSections = document.querySelectorAll('.content');
      contentSections.forEach(function(section) {
        section.classList.remove('show');
      });
      var contentToShow = document.getElementById(selectedCollection);
      if (contentToShow) {
        contentToShow.classList.add('show');
      }
    });
  });

});

// Comparison pop-up
function trappingKeyboardFocus() {
  const popup = document.getElementById('popup-content');
  const focusableElements = popup.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  const firstFocusableElement = focusableElements[0];
  const lastFocusableElement = focusableElements[focusableElements.length - 1];

  popup.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') {
      if (e.shiftKey) {
        if (document.activeElement === firstFocusableElement) {
          e.preventDefault();
          lastFocusableElement.focus();
        }
      } else {
        if (document.activeElement === lastFocusableElement) {
          e.preventDefault();
          firstFocusableElement.focus();
        }
      }
    }
  });

  document.querySelector('.close-button.compare-close')?.focus();
}

function handleEscapeKey(event) {
  if (event.key === 'Escape') {
    closePopup();
  }
}

let scrollPosition = 0;

function scrollTable(direction) {
  const container = document.querySelector('.scrollable-products');
  const product = document.querySelector('.scrollable-products .product-unit');

  const style = window.getComputedStyle(product);
  const productWidth = product.offsetWidth + parseFloat(style.marginLeft) + parseFloat(style.marginRight);

  const scrollAmount = productWidth + 21;

  const maxScrollLeft = container.scrollWidth - container.clientWidth;
  const currentScrollLeft = container.scrollLeft;

  if (direction === 1) {
    const newScrollLeft = Math.min(currentScrollLeft + scrollAmount, maxScrollLeft);
    container.scrollTo({
      left: newScrollLeft,
      behavior: 'smooth'
    });
  } else if (direction === -1) {
    const newScrollLeft = Math.max(currentScrollLeft - scrollAmount, 0);
    container.scrollTo({
      left: newScrollLeft,
      behavior: 'smooth'
    });
  }
}

calpak.scrollTable = scrollTable;

function updateArrowVisibility() {
  const container = document.querySelector('.scrollable-products');
  if(container){
    const scrollLeft = container.scrollLeft;
    const scrollWidth = container.scrollWidth;
    const clientWidth = container.clientWidth;

    const arrowLeft = document.querySelector('.arrow-left');
    const arrowRight = document.querySelector('.arrow-right');
    if(arrowLeft) arrowLeft.style.display = scrollLeft > 0 ? 'block' : 'none';
    if(arrowRight) arrowRight.style.display = scrollLeft < (scrollWidth - clientWidth - 1) ? 'block' : 'none';
  }
}

function hideEmptyRows() {
  const tbody = document.getElementById('comparison-table-body');
  if (tbody) {
    const rows = tbody.getElementsByTagName('tr');
    Array.from(rows).forEach(row => {
      const cells = row.getElementsByTagName('td');
      let allEmpty = true;

      Array.from(cells).forEach(cell => {
        const innerHTML = cell.innerHTML;

        const pTags = cell.querySelectorAll('p.comparison-table-keys-mobile');
        let contentToCheck = innerHTML;

        pTags.forEach(p => {
          contentToCheck = contentToCheck.replace(p.outerHTML, '');
        });

        if (contentToCheck.trim() !== '-' && contentToCheck.trim() !== '') {
          allEmpty = false;
        }
      });

      if (allEmpty) {
        row.style.display = 'none';
      }
    });
  }
}

function Popupopen() {
  scrollPosition = window.scrollY;
  document.getElementById('popup-content').classList.add('active');
  // document.getElementById('overlay').style.display = 'block';
  setTimeout(() => {
    document.body.classList.add('popup-open');
    if (window.innerWidth > 768) {
      trappingKeyboardFocus();
    }
    document.addEventListener('keydown', handleEscapeKey);

    const scrollableContainer = document.querySelector('.scrollable-products');
    if (scrollableContainer) {
      scrollableContainer.addEventListener('scroll', updateArrowVisibility);
      updateArrowVisibility();
    }
    window.addEventListener("resize", updateArrowVisibility);

    const sliders = scrollableContainer.querySelectorAll(".slider");
    // console.log('----- sliders', sliders.length)
    const observer = new IntersectionObserver(function(entries){
        entries.forEach(entry => {
            if (entry.intersectionRatio === 0) {
                return;
            }
            // entry.target.style.opacity = entry.intersectionRatio;

            observer.unobserve(entry.target);
            const slider = entry.target;
            const vertical = slider.classList.contains('slider--vertical') || (
                slider.classList.contains('slider--vertical-on-desktop')
                    && window.innerWidth > 900
            );

            slider.classList.add('scrolling-back');

            if (vertical) {
                slider.scrollTop = 0;
            } else {
                slider.scrollLeft = 0;
            }

            setTimeout(() => slider.classList.remove('scrolling-back'), 10);

            calpak.checkSlider(slider);
        });
    }, {
        threshold: 0,
        rootMargin: '0px'
    });

    sliders.forEach(slider => {
      calpak.checkSlider(slider);
        observer.observe(slider);
    });

  }, 100);
  hideEmptyRows();

  const td = document.querySelectorAll(".compare-popup-slider td");
  const th = document.querySelectorAll(".compare-popup-slider th");
  function updateProductWidth() {
    if(td?.length && th?.length){
      const viewportWidth = window.innerWidth;
      let productWidth;

      if (viewportWidth <= 680) {
        productWidth = `${(viewportWidth / 2) - 13}px`;
      }

      td.forEach(cell => cell.style.setProperty("--comparison-product-width", productWidth));
      th.forEach(cell => cell.style.setProperty("--comparison-product-width", productWidth));
    }
  }
  updateProductWidth();
  const debounceUpdateProductWidth = calpak.debounce(updateProductWidth, 100);
  window.addEventListener("resize", debounceUpdateProductWidth);
  calpak.hideProductsForCalifornia();
}

calpak.Popupopen = Popupopen;

const closePopup = function() {
  document.getElementById('popup-content').classList.remove('active');
  // document.getElementById('overlay').style.display = 'none';
  document.querySelector('#compare-pd')?.focus();
  setTimeout(() => {
    window.scrollTo({
      top: scrollPosition,
      behavior: 'smooth'
    });
    document.body.classList.remove('popup-open');
    document.removeEventListener('keydown', handleEscapeKey);
  }, 0);
  return false;
}
calpak.closePopup = closePopup


document.addEventListener("DOMContentLoaded", () => {
  // document.body.addEventListener('click', (event) => {
  //   if (event.target.id === 'compare-pd' || event.target.id === 'mobile-compare-pd') {
  //     Popupopen();
  //     event.preventDefault();
  //     event.stopPropagation();
  //   }
  // });

  document.getElementById('overlay')?.addEventListener('click', () => {
    closePopup();
  });

  document.getElementById('close-button')?.addEventListener('click', () => {
    closePopup();
  });
});

function nextprev() {
  let next = document.querySelector('.slider__control--next');
  let prev = document.querySelector('.slider__control--prev');
  const main = document.querySelector('.compare-pd-slide .product-unit');
  const ele = document.querySelector('.product-list .slider.slider--scrollbar');
  if(main != null && next != null)
  next.addEventListener('click', () => {
    const mainWidth = main.offsetWidth + 1;
    ele.scrollLeft += mainWidth;
  });

  if(main != null && prev != null)
  prev.addEventListener('click', () => {
    const mainWidth = main.offsetWidth + 1;
    ele.scrollLeft -= mainWidth;
  });

  const handleResize = () => {
    if(main != null && ele != null){
      const mainWidth = main.offsetWidth;
      ele.scrollLeft = mainWidth;
    }
  };

  if (main){
    handleResize();
    window.addEventListener('resize', handleResize);
  }
}

function setMaxHeightToPTags() {
  var maxHeight = {};

  ['.con-materials', '.con-weight', '.con-capacity', '.con-length-of-stay', '.con-carry-on-ready', '.con-handle-drop', '.con-strap-length', '.con-key-features', '.con-dimensions', '.comparison-popup .slider-info.grow,.comparison-popup .product-label--gift-gamification'].forEach(function (className) {
    var paragraphs = document.querySelectorAll(className);
    var max = 0;

    paragraphs.forEach(function (paragraph) {
      var height = paragraph.getBoundingClientRect().height;
      if (height > max) {
        max = height;
      }
    });

    maxHeight[className] = max;
  });

  Object.keys(maxHeight).forEach(function (className) {
    var paragraphs = document.querySelectorAll(className);
    paragraphs.forEach(function (paragraph) {
      paragraph.style.height = maxHeight[className] + 'px';
    });
  });
}

calpak.setMaxHeightToPTags = setMaxHeightToPTags;

document.addEventListener("DOMContentLoaded", () => {
  nextprev();

  if (document.getElementById('compare-pd')) {
    document.getElementById('compare-pd').addEventListener('click', function () {
      setTimeout(setMaxHeightToPTags, 200);
    });
  }

  if (document.getElementById('mobile-compare-pd')) {
    document.getElementById('mobile-compare-pd').addEventListener('click', function () {
      setTimeout(setMaxHeightToPTags, 200);
    });
  }
});

function updateMemorialSaleTimeout() {
  var countdown_ticks = document.querySelectorAll('.countdown-timer.memorial-countdown-timer');
  countdown_ticks.forEach(function (element) {
    element.style.display = 'block';
  });
  for (let i = 0; i < countdown_ticks.length; i++) {
    let time_left = parseInt(countdown_ticks[i].getAttribute('data-time'));
    let data_format = countdown_ticks[i].getAttribute('data-format');

    if (!time_left) {
      time_left = parseInt(countdown_ticks[i].getAttribute('data-time-left'));
      time_left--;
      countdown_ticks[i].setAttribute('data-time-left', time_left);
    } else {
      time_left--;
      countdown_ticks[i].setAttribute('data-time', time_left);
    }

    if (data_format == 'hour_min_second') {
      var d = 0;
    } else {
      var d = Math.floor(time_left / 86400); //Math.floor(time_left / 86400);
    }

    let h = Math.floor(time_left / 3600);
    let m = Math.floor((time_left - h * 3600) / 60);
    let s = (time_left % 3600) % 60;

    if (m < 10) m = '0' + m;
    if (s < 10) s = '0' + s;

    let timeLeftHtml = '';
    if (time_left < 0) {
      if (d > 0) {
        h -= 24 * d;
        if (h < 10) h = '0' + h;
        timeLeftHtml = '<span>00D</span>:<span>00H</span>:<span>00M</span>';
      } else {
        if (h < 10) h = '0' + h;
        timeLeftHtml = '<span>00</span>:<span>00</span>:<span>00</span>';
      }
    } else {
      if (d > 0) {
        h -= 24 * d;
        if (h < 10) h = '0' + h;
        timeLeftHtml =
          '<div>' +
          d +
          '<span>Days</span></div><span>:</span><div>' +
          h +
          '<span>Hours</span></div><span>:</span><div>' +
          m +
          '<span>Minutes</span></div>';
      } else {
        if (h < 10) h = '0' + h;
        timeLeftHtml =
          '<div>' +
          h +
          '<span>Hours</span></div><span>:</span><div>' +
          m +
          '<span>Minutes</span></div><span>:</span><div>' +
          s +
          '<span>Seconds</span></div>';
      }
    }

    if (time_left == 0) {
      // console.log('timer end');
      document.location.href = document.location.href;
      countdown_ticks[i].setAttribute('data-time', '-1');
    }

    countdown_ticks[i].innerHTML = timeLeftHtml;
  }
}

updateMemorialSaleTimeout();
window.addEventListener('load', () => {
  setInterval(() => updateMemorialSaleTimeout(), 1000);
});

window.addEventListener("load", () => {
  let items = document.querySelectorAll('.whr-item');
  items.forEach(item => {
    let dept = item.querySelector('.whr-dept span').nextSibling.textContent.trim();
    if (dept === 'Retail') {
      item.style.display = 'block';
    }
  });
});

function loadNoteClick(){
  document.querySelectorAll("span.note").forEach((item)=>{
    if(item.getAttribute("href") != null)
    {
      item.addEventListener("click", function(e){
        e.preventDefault();
        location.href = item.getAttribute("href");
      })
    }
  })
}

window.addEventListener("load", ()=>{
  loadNoteClick();
});

window.addEventListener("shopify:section:load", ()=>{
  loadNoteClick();
});

document.addEventListener('DOMContentLoaded', function() {
  const dateInput = document.getElementById('recipient-send-on');

  if (dateInput) {
      dateInput.addEventListener('change', function(event) {
          const selectedDate = new Date(event.target.value);
          const formattedDate = selectedDate.toISOString().split('T')[0];
          dateInput.value = formattedDate;
          dateInput.dataset.formattedDate = formattedDate;
      });

      // Ensure the date input value is correctly set when adding to cart
      document.querySelector('form').addEventListener('submit', function() {
          const selectedDate = new Date(dateInput.value);
          const formattedDate = selectedDate.toISOString().split('T')[0];
          dateInput.value = formattedDate;
          dateInput.dataset.formattedDate = formattedDate;
      });
  }
});
  document.addEventListener("calpak:loaded", function(){
    let headQuarterContent = document.querySelector('.career_headquarter_content #jobs');
    let careerBtn = document.querySelectorAll('.career-button');
    let jobSkeleton = document.getElementById('job-skeleton');
    if (headQuarterContent && jobSkeleton) {
      headQuarterContent.insertAdjacentElement('afterend', jobSkeleton);
    }
    careerBtn.forEach((btn)=>{
      if(btn){
          btn.style.display = "flex";
      }
    })
  });

  window.addEventListener("load", () => {
    let jobSkeleton = document.querySelector('#job-skeleton');
    let jobs = document.querySelector('#jobs');
    let main = document.querySelector('#whr_embed_hook');
    if(main){
      if (jobSkeleton) {
        jobSkeleton.style.display = 'none';
      }
      if (jobs){
        jobs.style.display = 'block';
      }

      let headings = document.querySelectorAll('#jobs h2');

      if (headings.length) {
          headings.forEach(function (heading) {
              var currentText = heading.textContent.trim();
              if (currentText === 'Marketing') {
                  heading.textContent = 'Headquarters';
              } else if (currentText === 'Operations') {
                  heading.textContent = 'Retail';
              }
          });
      }

      let departments = document.querySelectorAll('.whr-dept');

      let retailHeading = document.createElement('h2');
      retailHeading.classList.add('whr-group');
      retailHeading.innerHTML = 'Retail';

      let headquartersHeading = document.createElement('h2');
      headquartersHeading.classList.add('whr-group');
      headquartersHeading.innerHTML = 'Headquarters';

      main.appendChild(headquartersHeading)
      main.appendChild(retailHeading)

      let headquartersList = document.createElement('ul');
      headquartersList.className = 'whr-items';
      let retailList = document.createElement('ul');
      retailList.className = 'whr-items';

      departments.forEach((dept, i) => {
          let html = dept.innerHTML;
          let departmentName = html.replace('<span>Department:</span>', '').trim();

          let ele = dept.parentElement.parentElement;

          if (departmentName === "Retail") {
            retailList.appendChild(ele);
          } else {
            headquartersList.appendChild(ele);
          }
      });

      headquartersHeading.insertAdjacentElement('afterend', headquartersList);
      retailHeading.insertAdjacentElement('afterend', retailList);

      if (!headquartersList.querySelector('li')) {
          headquartersHeading.style.display = 'none';
      }
      if (!retailList.querySelector('li')) {
          retailHeading.style.display = 'none';
      }
    }

    function navigateToUpdatedLink(element) {
      const link = element.getAttribute("data-link");
      if (link) {
        window.location.href = link;
      }
    }

    function attachClickListener(selector) {
      const elements = document.querySelectorAll(selector);
      elements?.forEach((element) => {
        element.addEventListener("click", () => {
          navigateToUpdatedLink(element);
        });
      });
    }

    attachClickListener(".content-block__media");
    attachClickListener(".promo-collection__media");

    function getSortedChildren(parent) {
      const children = parent.children;
      const visibleItems = Array.from(children)
        .filter((child) => {
          const rect = child.getBoundingClientRect();
          const containerRect = parent.getBoundingClientRect();
          return (
            rect.top >= containerRect.top &&
            rect.left >= containerRect.left &&
            rect.bottom <= containerRect.bottom &&
            rect.right <= containerRect.right
          );
        })
        .map((el) => {
          const rect = el.getBoundingClientRect();
          return {
            el,
            top: rect.top,
            left: rect.left,
          };
        });
      visibleItems.sort((a, b) => {
        const rowDiff = a.top - b.top;
        return rowDiff !== 0 ? rowDiff : a.left - b.left;
      });
      
      return visibleItems;
    }

    const productGrids = document.querySelectorAll("ul.product-grid");
      productGrids.forEach((productGrid) => {
        const sortedUnits = getSortedChildren(productGrid);
        sortedUnits.forEach((unit, index) => {
          if (unit.el.classList.contains("product-card")) {
          } else {
            let count = 1;
            while(index + count < sortedUnits.length){
              if(sortedUnits[index + count].el.classList.contains("product-card")){
                productGrid.insertBefore(unit.el, sortedUnits[index + count].el);
                break;
              }
              else{
                count++;
              }
            };
            if (index + count < sortedUnits.length){
            }else {
              productGrid.insertBefore(
                unit.el,
                sortedUnits[index].el.nextSibling
              );
            }
          }
        });
      });
    });

  document.addEventListener("calpak:loaded", () => {
    const reviewsWrapper = document.querySelector(".review-custom__slider .reviews__slider");

    if (typeof reviewsWrapper !== "undefined" && reviewsWrapper) {

    const slides = document.querySelectorAll(".review-custom__slider .reviews__slide");
    const dots = document.querySelectorAll(".shopify-section--reviews .slider__dot.dot");
    const playPauseButton = document.querySelector(".review-custom__slider .play-pause-reviews");
    const playIcon = document.querySelector('.review-custom__slider .slider__play_icon');
    const pauseIcon = document.querySelector('.review-custom__slider .slider__pause_icon');
    const prevArrow = document.querySelector('.review-custom__slider .reviews-prev__arrow');
    const nextArrow = document.querySelector('.review-custom__slider .reviews-next__arrow');

    let currentSlide = 0, autoplayInterval, autoplayActive = true;
    let isDragging = false, startPos = 0, currentTranslate = 0, prevTranslate = 0;
    let screenWidth = slides[0].offsetWidth;
    let isScrolling = false;

    const transitionDuration = '0.5s';

    const updateScreenWidth = () => {
      screenWidth = slides[0].offsetWidth;
      if(reviewsWrapper)
      reviewsWrapper.style.cursor = window.innerWidth >= 900 ? 'auto' : 'grab';
    };

    const setSlideWidth = () => {
   //   slides.forEach(slide => slide.style.width = `${window.innerWidth}px`);
      if(reviewsWrapper)
      reviewsWrapper.style.transition = `transform ${transitionDuration} ease-in-out`;
    };

    window.addEventListener("resize", () => {
      setSlideWidth();
      updateScreenWidth();
      scrollToSlide(currentSlide);
    });

    const scrollToSlide = (index) => {
      const nextSlide = (index + slides.length) % slides.length;

      if (currentSlide === slides.length - 1 && nextSlide === 0) {
        reviewsWrapper.style.transition = 'none';
        reviewsWrapper.style.transform = `translateX(-${screenWidth * nextSlide}px)`;
        setTimeout(() => {
          reviewsWrapper.style.transition = `transform ${transitionDuration} ease-in-out`;
        }, 20);
      } else if (currentSlide === 0 && nextSlide === slides.length - 1) {
        reviewsWrapper.style.transition = 'none';
        reviewsWrapper.style.transform = `translateX(-${screenWidth * nextSlide}px)`;
        setTimeout(() => {
          reviewsWrapper.style.transition = `transform ${transitionDuration} ease-in-out`;
        }, 20);
      } else {
        reviewsWrapper.style.transition = `transform ${transitionDuration} ease-in-out`;
        reviewsWrapper.style.transform = `translateX(-${screenWidth * nextSlide}px)`;
      }

      currentSlide = nextSlide;

      slides.forEach((slide, i) => {
        slide.classList.remove("reviews__slide--active");
        slide.querySelectorAll('a').forEach(anchor => anchor.setAttribute('tabindex', '-1'));
        if (i === currentSlide) {
          slide.classList.add("reviews__slide--active");
          slide.querySelectorAll('a').forEach(anchor => anchor.removeAttribute('tabindex'));
        }
      });

      dots.forEach((dot, i) => {
        dot.classList.remove("slider__dot--active");
        if (i === currentSlide) {
          dot.classList.add("slider__dot--active");
        }
      });
    };

    const startAutoplay = () => {
      autoplayInterval = setInterval(() => scrollToSlide(currentSlide + 1), 8000);
      playIcon.style.display = 'none';
      pauseIcon.style.display = 'block';
      autoplayActive = true;
    };

    const stopAutoplay = () => {
      clearInterval(autoplayInterval);
      playIcon.style.display = 'block';
      pauseIcon.style.display = 'none';
      autoplayActive = false;
    };
    if(playPauseButton)
      playPauseButton.addEventListener("click", () => autoplayActive ? stopAutoplay() : startAutoplay());
    if(prevArrow)
      prevArrow.addEventListener("click", () => scrollToSlide(currentSlide - 1));
    if(nextArrow)
      nextArrow.addEventListener("click", () => scrollToSlide(currentSlide + 1));

    let wheelTimeout;
    const onWheelScroll = (e) => {
      if (screenWidth >= 900) {
        e.preventDefault();
        if (!isScrolling) {
          isScrolling = true;
          scrollToSlide(currentSlide + (e.deltaY > 0 ? 1 : -1));
          wheelTimeout = setTimeout(() => isScrolling = false, 400);
        }
      }
    };




    const dragStart = (e) => {
      if (screenWidth < 900) {
        isDragging = true;
        startPos = e.pageX || e.touches[0].clientX;
        reviewsWrapper.style.transition = 'none';
        prevTranslate = -currentSlide * window.innerWidth;
      }
    };

    const dragMove = (e) => {
      if (isDragging) {
        const currentPos = e.pageX || e.touches[0].clientX;
        currentTranslate = prevTranslate + currentPos - startPos;
        reviewsWrapper.style.transform = `translateX(${currentTranslate}px)`;
      }
    };

    const dragEnd = () => {
      if (isDragging) {
        isDragging = false;
        const movedBy = currentTranslate - prevTranslate;

        if (movedBy < -100) {
          scrollToSlide(currentSlide + 1);
        } else if (movedBy > 100) {
          scrollToSlide(currentSlide - 1);
        } else {
          scrollToSlide(currentSlide);
        }
      }
    };


    // reviewsWrapper?.addEventListener('mousedown', dragStart);
    // reviewsWrapper?.addEventListener('mousemove', dragMove);
    // reviewsWrapper?.addEventListener('mouseup', dragEnd);
    // reviewsWrapper?.addEventListener('mouseleave', dragEnd);
    // reviewsWrapper?.addEventListener('touchstart', dragStart);
    // reviewsWrapper?.addEventListener('touchmove', dragMove);
    // reviewsWrapper?.addEventListener('touchend', dragEnd);


    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        scrollToSlide(index);
      });
    });

    setSlideWidth();
    updateScreenWidth();
    startAutoplay();
    scrollToSlide(0);

  }
  });

function handleReadMore (element) {
  // console.log("toggle")
  const toggleButton = document.querySelector('.toggle-btn');
  const textContent = document.querySelector(element);

  if (typeof textContent == 'undefined' || textContent == null) return;
  const links = textContent.querySelectorAll('a');

  function checkContentHeight() {
      const lineHeight = parseInt(window.getComputedStyle(textContent).lineHeight);
      const maxHeight = lineHeight * 3;

      textContent.classList.add('expanded');
      const isContentOverflowing = textContent.scrollHeight >= maxHeight;
      textContent.classList.remove('expanded');

      if (typeof toggleButton != 'undefined'){
          if (isContentOverflowing) {
              toggleButton.style.display = 'block';
              if (!textContent.classList.contains('expanded')) {
                  toggleButton.textContent = 'Read More';
                  toggleButton.setAttribute('aria-expanded', 'false');
                  manageLinkVisibility(maxHeight);
              }
          } else {
              toggleButton.style.display = 'none';
              toggleButton.textContent = 'Read More';
              toggleButton.setAttribute('aria-expanded', 'false');
              textContent.classList.remove('expanded');
              showAllLinks();
          }
      }
  }

  function manageLinkVisibility(maxHeight) {
      links.forEach(link => {
          if (link.offsetTop > maxHeight) {
              link.style.display = 'none';
          } else {
              link.style.display = '';
          }
      });
  }


  function showAllLinks() {
      links.forEach(link => {
          link.style.display = '';
      });
  }

  checkContentHeight();

  window.addEventListener('resize', () => {
    if (!textContent.classList.contains('expanded')) {
      checkContentHeight();
    }
  });


  if (typeof toggleButton != 'undefined') {
      toggleButton.addEventListener('click', function() {
          const expanded = textContent.classList.toggle('expanded');
          toggleButton.textContent = expanded ? 'Read Less' : 'Read More';
          toggleButton.setAttribute('aria-expanded', expanded);
          if (expanded) {
              showAllLinks();
          } else {
              checkContentHeight();
          }
      });
  }
}

document.addEventListener("calpak:ready", function () {

    document.body.addEventListener("click", function (event) {
      if(event.target.closest("[data-nav-link]"))
      {
        window.location.href = event.target.closest("[data-nav-link]").getAttribute("data-nav-link");
      }
    });

  handleReadMore(".custom-html__content .text");
  // .plp-block-content is handled in sections/plp-block.liquid (multi-variant + filter URLs)
  handleReadMore(".pdp-description_content .accordion__content");

  const textSlider = document.querySelector(".text-slider__wrapper .slider");
  if (!textSlider) return;

  let isDragging = false;
  let startX = 0;
  let scrollLeft = 0;

  textSlider.addEventListener("mousedown", (e) => {
    isDragging = true;
    textSlider.classList.add("dragging");
    startX = e.pageX - textSlider.offsetLeft;
    scrollLeft = textSlider.scrollLeft;
  });

  textSlider.addEventListener("mousemove", (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - textSlider.offsetLeft;
    const walk = (x - startX) * 1.5;
    textSlider.scrollLeft = scrollLeft - walk;
  });

  textSlider.addEventListener("mouseup", () => {
    isDragging = false;
    textSlider.classList.remove("dragging");
  });

  textSlider.addEventListener("mouseleave", () => {
    isDragging = false;
    textSlider.classList.remove("dragging");
  });
});

calpak.hideProductsForCalifornia = function hideProductsForCalifornia() {
  if (calpak.userRegionCode !== "CA" || !calpak?.hideSkusCalifornia?.length) {
    return;
  }

  const restrictedSkus = new Set(calpak.hideSkusCalifornia.map(sku => sku.toUpperCase()));

  const handleProductUnit = (productUnit) => {
    const activeSwatch = productUnit.querySelector(".color-swatch--active");
    if (!activeSwatch) return;

    const sku = activeSwatch.getAttribute("data-sku")?.toUpperCase();
    if (!sku) return;

    const isRestricted = restrictedSkus.has(sku);
    productUnit.classList.toggle("product-unit--na", isRestricted);
    productUnit.classList.toggle("product-unit--jw", isRestricted);
  };

  const handleSwatches = (productUnit) => {
    productUnit.querySelectorAll(".color-swatch").forEach(swatch => {
      const sku = swatch.getAttribute("data-sku")?.toUpperCase();
      if (sku && restrictedSkus.has(sku)) {
        swatch.classList.add("product-option--na-california");
        swatch.classList.remove("product-option--na");
      }
    });
  };

  document.querySelectorAll(".product-unit").forEach(productUnit => {
    handleProductUnit(productUnit);
    handleSwatches(productUnit);
  });
}

document.addEventListener("calpak:loaded", async function () {
  const featuredProductsGrid = document.querySelector('.featured-products--grid');
  const productCards = document.querySelectorAll('.featured-products--grid .custom-attr');

  if(featuredProductsGrid) {
    const color = featuredProductsGrid.getAttribute('data-color');
    calpak.applyColorToProductCard(productCards, color);
  }

  const loginForm = document.querySelector('#customer_login');
  const registerForm = document.querySelector('#create_customer');

  function initCaptcha(form) {
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      window.Shopify.captcha.protect(form, () => {
        form.submit();
      });
    });
  }
  if (loginForm) {
    initCaptcha(loginForm);
  }
  if (registerForm) {
    initCaptcha(registerForm);
  }
});

// // temp disable california check
// document.addEventListener("calpak:loaded", async function () {
//   console.log('-------------- hideProductsForCalifornia - calpak:loaded')
//   console.log(calpak.userRegionCode)
//
//   if (!calpak.userLocationData){
//     await calpak.setLocation();
//   }
//
//   if (calpak.userRegionCode === "CA") {
//     document.body.classList.add("california");
//   } else {
//     document.body.classList.remove("california");
//   }
//
//   calpak.hideProductsForCalifornia();
// });



function initPromoCodeCopy() {
  document.querySelectorAll('.highlight_promo_code').forEach(wrapper => {
    // Only attach a listener once per element
    if (wrapper.classList.contains('listener-added')) return;

    const textNode = Array.from(wrapper.childNodes).find(n => n.nodeType === Node.TEXT_NODE);
    const button = wrapper.querySelector('.copy-text-btn');

    if (!textNode || !button) return;

    const originalCode = textNode.nodeValue.trim();
    const originalIcon = button.innerHTML;

    const onClick = function () {
      navigator.clipboard.writeText(originalCode).then(() => {
        textNode.nodeValue = "Copied ";
        button.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20" width="38" height="38">
            <path d="M7.629 13.314L3.928 9.614 2.514 11.029l5.115 5.115L17.485 6.288 16.071 4.873z"/>
          </svg>`;
        wrapper.classList.add("active");

        setTimeout(() => {
          textNode.nodeValue = originalCode + ' ';
          button.innerHTML = originalIcon;
          wrapper.classList.remove("active");
        }, 2000);
      }).catch(err => console.error("Failed to copy:", err));
    };

    wrapper.addEventListener('click', onClick);
    wrapper.classList.add('listener-added');
  });
}

// Initialize on calpak loaded
document.addEventListener("calpak:loaded", function () {
  initPromoCodeCopy();
});

// expose for manual re-initialization if needed
if (typeof calpak !== 'undefined') calpak.initPromoCodeCopy = initPromoCodeCopy;



/* back to top JS*/
document.addEventListener("calpak:loaded", function () {
  const backToTopButton = document.getElementById("backToTop");

  window.addEventListener("scroll", function () {
    if (window.scrollY > 300) {
      backToTopButton.classList.add("visible");
    } else {
      backToTopButton.classList.remove("visible");
    }
  });

  backToTopButton.addEventListener("click", function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
});

function trapFocus(container) {
  const focusable = container.querySelectorAll(
    'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
  );
  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  container.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') {
      if (e.shiftKey) {
        // Shift+Tab
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        // Tab
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
  });
}

// Manage focusability of elements inside aria-hidden containers
function updateAriaHiddenFocusability() {
  // Find all elements with aria-hidden
  document.querySelectorAll('[aria-hidden="true"]').forEach(container => {
    // Find all focusable elements inside
    const focusableElements = container.querySelectorAll(
      'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );

    // Set tabindex="-1" on all focusable elements
    focusableElements.forEach(element => {
      if (!element.hasAttribute('data-original-tabindex')) {
        const currentTabindex = element.getAttribute('tabindex');
        if (currentTabindex !== null && currentTabindex !== '-1') {
          element.setAttribute('data-original-tabindex', currentTabindex);
        }
      }
      element.setAttribute('tabindex', '-1');
    });
  });

  // Restore focusability for elements not in aria-hidden containers
  document.querySelectorAll('[data-original-tabindex]').forEach(element => {
    const isInAriaHidden = element.closest('[aria-hidden="true"]');
    if (!isInAriaHidden) {
      const originalTabindex = element.getAttribute('data-original-tabindex');
      element.setAttribute('tabindex', originalTabindex);
      element.removeAttribute('data-original-tabindex');
    }
  });
}

// Run on page load and when DOM changes
document.addEventListener('DOMContentLoaded', () => {
  updateAriaHiddenFocusability();
  // Run again after a delay to catch any dynamically initialized elements
  setTimeout(updateAriaHiddenFocusability, 500);
  setTimeout(updateAriaHiddenFocusability, 1000);
});

// Also run when custom calpak:loaded event fires
document.addEventListener('calpak:loaded', () => {
  updateAriaHiddenFocusability();
  // Run again after a delay to catch sliders that initialize after this event
  setTimeout(updateAriaHiddenFocusability, 500);
});

// Watch for aria-hidden changes
const ariaObserver = new MutationObserver(() => {
  updateAriaHiddenFocusability();
});

ariaObserver.observe(document.body, {
  attributes: true,
  attributeFilter: ['aria-hidden'],
  subtree: true
});

/* Lazy Load Tolstoy */
document.addEventListener("DOMContentLoaded", () => {
  const wrappers = document.querySelectorAll('.tolstoy-lazy-wrapper');
  if (!wrappers.length) return;

  const mountWidget = (el) => {
    if (el.dataset.loaded) return;

    const id = el.dataset.tolstoyPublicId;

    el.innerHTML = `
      <tolstoy-carousel 
        data-tags="" 
        class="tolstoy-carousel" 
        data-publish-id="${id}"
      ></tolstoy-carousel>
    `;

    window.Tolstoy?.load();

    el.dataset.loaded = "true";
  };

  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        mountWidget(entry.target);
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: "300px 0px" });

  wrappers.forEach(w => io.observe(w));
});

calpak.trapFocus = trapFocus